import { onMounted as Bt, onUnmounted as Di, ref as K, defineComponent as Tt, useSlots as Ci, watch as jt, computed as D, onBeforeUpdate as Ea, createElementBlock as G, openBlock as B, renderSlot as ot, Fragment as zt, createElementVNode as F, unref as it, renderList as te, normalizeStyle as gt, watchEffect as hr, nextTick as Aa, createBlock as Na, createCommentVNode as _t, resolveDynamicComponent as Pa, Teleport as Ua, withCtx as Oa, normalizeClass as At, mergeProps as dr, toDisplayString as vt, toRefs as Fa, normalizeProps as Ya, guardReactiveProps as Ia, createTextVNode as Wa, useCssVars as $i } from "vue";
import { toPixels as bt, useColorTheme as Ra } from "@prefecthq/prefect-design";
import { useElementRect as Ut, useKeyDown as Ei, useNow as za } from "@prefecthq/vue-compositions";
function Ke(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function La(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function mr(t) {
  let e, n, r;
  t.length !== 2 ? (e = Ke, n = (s, l) => Ke(t(s), l), r = (s, l) => t(s) - l) : (e = t === Ke || t === La ? t : Ha, n = t, r = t);
  function i(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (e(l, l) !== 0) return c;
      do {
        const f = u + c >>> 1;
        n(s[f], l) < 0 ? u = f + 1 : c = f;
      } while (u < c);
    }
    return u;
  }
  function a(s, l, u = 0, c = s.length) {
    if (u < c) {
      if (e(l, l) !== 0) return c;
      do {
        const f = u + c >>> 1;
        n(s[f], l) <= 0 ? u = f + 1 : c = f;
      } while (u < c);
    }
    return u;
  }
  function o(s, l, u = 0, c = s.length) {
    const f = i(s, l, u, c - 1);
    return f > u && r(s[f - 1], l) > -r(s[f], l) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function Ha() {
  return 0;
}
function Xa(t) {
  return t === null ? NaN : +t;
}
const Va = mr(Ke), qa = Va.right;
mr(Xa).center;
function Pr(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
const Ba = Math.sqrt(50), Ga = Math.sqrt(10), Qa = Math.sqrt(2);
function sn(t, e, n) {
  const r = (e - t) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / Math.pow(10, i), o = a >= Ba ? 10 : a >= Ga ? 5 : a >= Qa ? 2 : 1;
  let s, l, u;
  return i < 0 ? (u = Math.pow(10, -i) / o, s = Math.round(t * u), l = Math.round(e * u), s / u < t && ++s, l / u > e && --l, u = -u) : (u = Math.pow(10, i) * o, s = Math.round(t / u), l = Math.round(e / u), s * u < t && ++s, l * u > e && --l), l < s && 0.5 <= n && n < 2 ? sn(t, e, n * 2) : [s, l, u];
}
function Za(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [i, a, o] = r ? sn(e, t, n) : sn(t, e, n);
  if (!(a >= i)) return [];
  const s = a - i + 1, l = new Array(s);
  if (r)
    if (o < 0) for (let u = 0; u < s; ++u) l[u] = (a - u) / -o;
    else for (let u = 0; u < s; ++u) l[u] = (a - u) * o;
  else if (o < 0) for (let u = 0; u < s; ++u) l[u] = (i + u) / -o;
  else for (let u = 0; u < s; ++u) l[u] = (i + u) * o;
  return l;
}
function Bn(t, e, n) {
  return e = +e, t = +t, n = +n, sn(t, e, n)[2];
}
function Gn(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, i = r ? Bn(e, t, n) : Bn(t, e, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Ka(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = t + r * n;
  return a;
}
function Ja(t) {
  return t;
}
var Je = 1, Pn = 2, Qn = 3, Ce = 4, Ur = 1e-6;
function ja(t) {
  return "translate(" + t + ",0)";
}
function to(t) {
  return "translate(0," + t + ")";
}
function eo(t) {
  return (e) => +t(e);
}
function no(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function ro() {
  return !this.__axis;
}
function gr(t, e) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, l = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5, u = t === Je || t === Ce ? -1 : 1, c = t === Ce || t === Pn ? "x" : "y", f = t === Je || t === Qn ? ja : to;
  function h(g) {
    var S = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()), M = i ?? (e.tickFormat ? e.tickFormat.apply(e, n) : Ja), A = Math.max(a, 0) + s, x = e.range(), Y = +x[0] + l, $ = +x[x.length - 1] + l, d = (e.bandwidth ? no : eo)(e.copy(), l), m = g.selection ? g.selection() : g, p = m.selectAll(".domain").data([null]), v = m.selectAll(".tick").data(S, e).order(), b = v.exit(), C = v.enter().append("g").attr("class", "tick"), R = v.select("line"), w = v.select("text");
    p = p.merge(p.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), v = v.merge(C), R = R.merge(C.append("line").attr("stroke", "currentColor").attr(c + "2", u * a)), w = w.merge(C.append("text").attr("fill", "currentColor").attr(c, u * A).attr("dy", t === Je ? "0em" : t === Qn ? "0.71em" : "0.32em")), g !== m && (p = p.transition(g), v = v.transition(g), R = R.transition(g), w = w.transition(g), b = b.transition(g).attr("opacity", Ur).attr("transform", function(X) {
      return isFinite(X = d(X)) ? f(X + l) : this.getAttribute("transform");
    }), C.attr("opacity", Ur).attr("transform", function(X) {
      var Q = this.parentNode.__axis;
      return f((Q && isFinite(Q = Q(X)) ? Q : d(X)) + l);
    })), b.remove(), p.attr("d", t === Ce || t === Pn ? o ? "M" + u * o + "," + Y + "H" + l + "V" + $ + "H" + u * o : "M" + l + "," + Y + "V" + $ : o ? "M" + Y + "," + u * o + "V" + l + "H" + $ + "V" + u * o : "M" + Y + "," + l + "H" + $), v.attr("opacity", 1).attr("transform", function(X) {
      return f(d(X) + l);
    }), R.attr(c + "2", u * a), w.attr(c, u * A).text(M), m.filter(ro).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === Pn ? "start" : t === Ce ? "end" : "middle"), m.each(function() {
      this.__axis = d;
    });
  }
  return h.scale = function(g) {
    return arguments.length ? (e = g, h) : e;
  }, h.ticks = function() {
    return n = Array.from(arguments), h;
  }, h.tickArguments = function(g) {
    return arguments.length ? (n = g == null ? [] : Array.from(g), h) : n.slice();
  }, h.tickValues = function(g) {
    return arguments.length ? (r = g == null ? null : Array.from(g), h) : r && r.slice();
  }, h.tickFormat = function(g) {
    return arguments.length ? (i = g, h) : i;
  }, h.tickSize = function(g) {
    return arguments.length ? (a = o = +g, h) : a;
  }, h.tickSizeInner = function(g) {
    return arguments.length ? (a = +g, h) : a;
  }, h.tickSizeOuter = function(g) {
    return arguments.length ? (o = +g, h) : o;
  }, h.tickPadding = function(g) {
    return arguments.length ? (s = +g, h) : s;
  }, h.offset = function(g) {
    return arguments.length ? (l = +g, h) : l;
  }, h;
}
function io(t) {
  return gr(Je, t);
}
function Ai(t) {
  return gr(Qn, t);
}
function ao(t) {
  return gr(Ce, t);
}
var oo = { value: () => {
} };
function Tn() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new je(n);
}
function je(t) {
  this._ = t;
}
function so(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
je.prototype = Tn.prototype = {
  constructor: je,
  on: function(t, e) {
    var n = this._, r = so(t + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; ) if ((i = (t = r[a]).type) && (i = uo(n[i], t.name))) return i;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++a < o; )
      if (i = (t = r[a]).type) n[i] = Or(n[i], t.name, e);
      else if (e == null) for (i in n) n[i] = Or(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new je(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (a = this._[t], r = 0, i = a.length; r < i; ++r) a[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, a = r.length; i < a; ++i) r[i].value.apply(e, n);
  }
};
function uo(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function Or(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = oo, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var Zn = "http://www.w3.org/1999/xhtml";
const Fr = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Zn,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Sn(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), Fr.hasOwnProperty(e) ? { space: Fr[e], local: t } : t;
}
function lo(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === Zn && e.documentElement.namespaceURI === Zn ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function co(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Ni(t) {
  var e = Sn(t);
  return (e.local ? co : lo)(e);
}
function fo() {
}
function vr(t) {
  return t == null ? fo : function() {
    return this.querySelector(t);
  };
}
function ho(t) {
  typeof t != "function" && (t = vr(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = new Array(o), l, u, c = 0; c < o; ++c)
      (l = a[c]) && (u = t.call(l, l.__data__, c, a)) && ("__data__" in l && (u.__data__ = l.__data__), s[c] = u);
  return new Mt(r, this._parents);
}
function mo(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function go() {
  return [];
}
function Pi(t) {
  return t == null ? go : function() {
    return this.querySelectorAll(t);
  };
}
function vo(t) {
  return function() {
    return mo(t.apply(this, arguments));
  };
}
function po(t) {
  typeof t == "function" ? t = vo(t) : t = Pi(t);
  for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = e[a], s = o.length, l, u = 0; u < s; ++u)
      (l = o[u]) && (r.push(t.call(l, l.__data__, u, o)), i.push(l));
  return new Mt(r, i);
}
function Ui(t) {
  return function() {
    return this.matches(t);
  };
}
function Oi(t) {
  return function(e) {
    return e.matches(t);
  };
}
var _o = Array.prototype.find;
function yo(t) {
  return function() {
    return _o.call(this.children, t);
  };
}
function wo() {
  return this.firstElementChild;
}
function xo(t) {
  return this.select(t == null ? wo : yo(typeof t == "function" ? t : Oi(t)));
}
var bo = Array.prototype.filter;
function Mo() {
  return Array.from(this.children);
}
function To(t) {
  return function() {
    return bo.call(this.children, t);
  };
}
function So(t) {
  return this.selectAll(t == null ? Mo : To(typeof t == "function" ? t : Oi(t)));
}
function ko(t) {
  typeof t != "function" && (t = Ui(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, u = 0; u < o; ++u)
      (l = a[u]) && t.call(l, l.__data__, u, a) && s.push(l);
  return new Mt(r, this._parents);
}
function Fi(t) {
  return new Array(t.length);
}
function Do() {
  return new Mt(this._enter || this._groups.map(Fi), this._parents);
}
function un(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
un.prototype = {
  constructor: un,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function Co(t) {
  return function() {
    return t;
  };
}
function $o(t, e, n, r, i, a) {
  for (var o = 0, s, l = e.length, u = a.length; o < u; ++o)
    (s = e[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new un(t, a[o]);
  for (; o < l; ++o)
    (s = e[o]) && (i[o] = s);
}
function Eo(t, e, n, r, i, a, o) {
  var s, l, u = /* @__PURE__ */ new Map(), c = e.length, f = a.length, h = new Array(c), g;
  for (s = 0; s < c; ++s)
    (l = e[s]) && (h[s] = g = o.call(l, l.__data__, s, e) + "", u.has(g) ? i[s] = l : u.set(g, l));
  for (s = 0; s < f; ++s)
    g = o.call(t, a[s], s, a) + "", (l = u.get(g)) ? (r[s] = l, l.__data__ = a[s], u.delete(g)) : n[s] = new un(t, a[s]);
  for (s = 0; s < c; ++s)
    (l = e[s]) && u.get(h[s]) === l && (i[s] = l);
}
function Ao(t) {
  return t.__data__;
}
function No(t, e) {
  if (!arguments.length) return Array.from(this, Ao);
  var n = e ? Eo : $o, r = this._parents, i = this._groups;
  typeof t != "function" && (t = Co(t));
  for (var a = i.length, o = new Array(a), s = new Array(a), l = new Array(a), u = 0; u < a; ++u) {
    var c = r[u], f = i[u], h = f.length, g = Po(t.call(c, c && c.__data__, u, r)), S = g.length, M = s[u] = new Array(S), A = o[u] = new Array(S), x = l[u] = new Array(h);
    n(c, f, M, A, x, g, e);
    for (var Y = 0, $ = 0, d, m; Y < S; ++Y)
      if (d = M[Y]) {
        for (Y >= $ && ($ = Y + 1); !(m = A[$]) && ++$ < S; ) ;
        d._next = m || null;
      }
  }
  return o = new Mt(o, r), o._enter = s, o._exit = l, o;
}
function Po(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Uo() {
  return new Mt(this._exit || this._groups.map(Fi), this._parents);
}
function Oo(t, e, n) {
  var r = this.enter(), i = this, a = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
function Fo(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), l = 0; l < o; ++l)
    for (var u = n[l], c = r[l], f = u.length, h = s[l] = new Array(f), g, S = 0; S < f; ++S)
      (g = u[S] || c[S]) && (h[S] = g);
  for (; l < i; ++l)
    s[l] = n[l];
  return new Mt(s, this._parents);
}
function Yo() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function Io(t) {
  t || (t = Wo);
  function e(f, h) {
    return f && h ? t(f.__data__, h.__data__) : !f - !h;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, l = i[a] = new Array(s), u, c = 0; c < s; ++c)
      (u = o[c]) && (l[c] = u);
    l.sort(e);
  }
  return new Mt(i, this._parents).order();
}
function Wo(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Ro() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function zo() {
  return Array.from(this);
}
function Lo() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function Ho() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function Xo() {
  return !this.node();
}
function Vo(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && t.call(s, s.__data__, a, i);
  return this;
}
function qo(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Bo(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Go(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function Qo(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function Zo(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function Ko(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function Jo(t, e) {
  var n = Sn(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Bo : qo : typeof e == "function" ? n.local ? Ko : Zo : n.local ? Qo : Go)(n, e));
}
function Yi(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function jo(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function ts(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function es(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function ns(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? jo : typeof e == "function" ? es : ts)(t, e, n ?? "")) : me(this.node(), t);
}
function me(t, e) {
  return t.style.getPropertyValue(e) || Yi(t).getComputedStyle(t, null).getPropertyValue(e);
}
function rs(t) {
  return function() {
    delete this[t];
  };
}
function is(t, e) {
  return function() {
    this[t] = e;
  };
}
function as(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function os(t, e) {
  return arguments.length > 1 ? this.each((e == null ? rs : typeof e == "function" ? as : is)(t, e)) : this.node()[t];
}
function Ii(t) {
  return t.trim().split(/^|\s+/);
}
function pr(t) {
  return t.classList || new Wi(t);
}
function Wi(t) {
  this._node = t, this._names = Ii(t.getAttribute("class") || "");
}
Wi.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function Ri(t, e) {
  for (var n = pr(t), r = -1, i = e.length; ++r < i; ) n.add(e[r]);
}
function zi(t, e) {
  for (var n = pr(t), r = -1, i = e.length; ++r < i; ) n.remove(e[r]);
}
function ss(t) {
  return function() {
    Ri(this, t);
  };
}
function us(t) {
  return function() {
    zi(this, t);
  };
}
function ls(t, e) {
  return function() {
    (e.apply(this, arguments) ? Ri : zi)(this, t);
  };
}
function cs(t, e) {
  var n = Ii(t + "");
  if (arguments.length < 2) {
    for (var r = pr(this.node()), i = -1, a = n.length; ++i < a; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? ls : e ? ss : us)(n, e));
}
function fs() {
  this.textContent = "";
}
function hs(t) {
  return function() {
    this.textContent = t;
  };
}
function ds(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function ms(t) {
  return arguments.length ? this.each(t == null ? fs : (typeof t == "function" ? ds : hs)(t)) : this.node().textContent;
}
function gs() {
  this.innerHTML = "";
}
function vs(t) {
  return function() {
    this.innerHTML = t;
  };
}
function ps(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function _s(t) {
  return arguments.length ? this.each(t == null ? gs : (typeof t == "function" ? ps : vs)(t)) : this.node().innerHTML;
}
function ys() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function ws() {
  return this.each(ys);
}
function xs() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function bs() {
  return this.each(xs);
}
function Ms(t) {
  var e = typeof t == "function" ? t : Ni(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function Ts() {
  return null;
}
function Ss(t, e) {
  var n = typeof t == "function" ? t : Ni(t), r = e == null ? Ts : typeof e == "function" ? e : vr(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function ks() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Ds() {
  return this.each(ks);
}
function Cs() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function $s() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Es(t) {
  return this.select(t ? $s : Cs);
}
function As(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Ns(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function Ps(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function Us(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, a; n < i; ++n)
        a = e[n], (!t.type || a.type === t.type) && a.name === t.name ? this.removeEventListener(a.type, a.listener, a.options) : e[++r] = a;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function Os(t, e, n) {
  return function() {
    var r = this.__on, i, a = Ns(e);
    if (r) {
      for (var o = 0, s = r.length; o < s; ++o)
        if ((i = r[o]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, a, n), i = { type: t.type, name: t.name, value: e, listener: a, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function Fs(t, e, n) {
  var r = Ps(t + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, u = s.length, c; l < u; ++l)
        for (i = 0, c = s[l]; i < a; ++i)
          if ((o = r[i]).type === c.type && o.name === c.name)
            return c.value;
    }
    return;
  }
  for (s = e ? Os : Us, i = 0; i < a; ++i) this.each(s(r[i], e, n));
  return this;
}
function Li(t, e, n) {
  var r = Yi(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function Ys(t, e) {
  return function() {
    return Li(this, t, e);
  };
}
function Is(t, e) {
  return function() {
    return Li(this, t, e.apply(this, arguments));
  };
}
function Ws(t, e) {
  return this.each((typeof e == "function" ? Is : Ys)(t, e));
}
function* Rs() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length, o; i < a; ++i)
      (o = r[i]) && (yield o);
}
var Hi = [null];
function Mt(t, e) {
  this._groups = t, this._parents = e;
}
function Ye() {
  return new Mt([[document.documentElement]], Hi);
}
function zs() {
  return this;
}
Mt.prototype = Ye.prototype = {
  constructor: Mt,
  select: ho,
  selectAll: po,
  selectChild: xo,
  selectChildren: So,
  filter: ko,
  data: No,
  enter: Do,
  exit: Uo,
  join: Oo,
  merge: Fo,
  selection: zs,
  order: Yo,
  sort: Io,
  call: Ro,
  nodes: zo,
  node: Lo,
  size: Ho,
  empty: Xo,
  each: Vo,
  attr: Jo,
  style: ns,
  property: os,
  classed: cs,
  text: ms,
  html: _s,
  raise: ws,
  lower: bs,
  append: Ms,
  insert: Ss,
  remove: Ds,
  clone: Es,
  datum: As,
  on: Fs,
  dispatch: Ws,
  [Symbol.iterator]: Rs
};
function lt(t) {
  return typeof t == "string" ? new Mt([[document.querySelector(t)]], [document.documentElement]) : new Mt([[t]], Hi);
}
function Ls(t) {
  let e;
  for (; e = t.sourceEvent; ) t = e;
  return t;
}
function pt(t, e) {
  if (t = Ls(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
const Hs = { passive: !1 }, Ne = { capture: !0, passive: !1 };
function Un(t) {
  t.stopImmediatePropagation();
}
function he(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Xi(t) {
  var e = t.document.documentElement, n = lt(t).on("dragstart.drag", he, Ne);
  "onselectstart" in e ? n.on("selectstart.drag", he, Ne) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function Vi(t, e) {
  var n = t.document.documentElement, r = lt(t).on("dragstart.drag", null);
  e && (r.on("click.drag", he, Ne), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const Le = (t) => () => t;
function Kn(t, {
  sourceEvent: e,
  subject: n,
  target: r,
  identifier: i,
  active: a,
  x: o,
  y: s,
  dx: l,
  dy: u,
  dispatch: c
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: u, enumerable: !0, configurable: !0 },
    _: { value: c }
  });
}
Kn.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function Xs(t) {
  return !t.ctrlKey && !t.button;
}
function Vs() {
  return this.parentNode;
}
function qs(t, e) {
  return e ?? { x: t.x, y: t.y };
}
function Bs() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function tn() {
  var t = Xs, e = Vs, n = qs, r = Bs, i = {}, a = Tn("start", "drag", "end"), o = 0, s, l, u, c, f = 0;
  function h(d) {
    d.on("mousedown.drag", g).filter(r).on("touchstart.drag", A).on("touchmove.drag", x, Hs).on("touchend.drag touchcancel.drag", Y).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function g(d, m) {
    if (!(c || !t.call(this, d, m))) {
      var p = $(this, e.call(this, d, m), d, m, "mouse");
      p && (lt(d.view).on("mousemove.drag", S, Ne).on("mouseup.drag", M, Ne), Xi(d.view), Un(d), u = !1, s = d.clientX, l = d.clientY, p("start", d));
    }
  }
  function S(d) {
    if (he(d), !u) {
      var m = d.clientX - s, p = d.clientY - l;
      u = m * m + p * p > f;
    }
    i.mouse("drag", d);
  }
  function M(d) {
    lt(d.view).on("mousemove.drag mouseup.drag", null), Vi(d.view, u), he(d), i.mouse("end", d);
  }
  function A(d, m) {
    if (t.call(this, d, m)) {
      var p = d.changedTouches, v = e.call(this, d, m), b = p.length, C, R;
      for (C = 0; C < b; ++C)
        (R = $(this, v, d, m, p[C].identifier, p[C])) && (Un(d), R("start", d, p[C]));
    }
  }
  function x(d) {
    var m = d.changedTouches, p = m.length, v, b;
    for (v = 0; v < p; ++v)
      (b = i[m[v].identifier]) && (he(d), b("drag", d, m[v]));
  }
  function Y(d) {
    var m = d.changedTouches, p = m.length, v, b;
    for (c && clearTimeout(c), c = setTimeout(function() {
      c = null;
    }, 500), v = 0; v < p; ++v)
      (b = i[m[v].identifier]) && (Un(d), b("end", d, m[v]));
  }
  function $(d, m, p, v, b, C) {
    var R = a.copy(), w = pt(C || p, m), X, Q, _;
    if ((_ = n.call(d, new Kn("beforestart", {
      sourceEvent: p,
      target: h,
      identifier: b,
      active: o,
      x: w[0],
      y: w[1],
      dx: 0,
      dy: 0,
      dispatch: R
    }), v)) != null)
      return X = _.x - w[0] || 0, Q = _.y - w[1] || 0, function P(y, O, W) {
        var I = w, L;
        switch (y) {
          case "start":
            i[b] = P, L = o++;
            break;
          case "end":
            delete i[b], --o;
          // falls through
          case "drag":
            w = pt(W || O, m), L = o;
            break;
        }
        R.call(
          y,
          d,
          new Kn(y, {
            sourceEvent: O,
            subject: _,
            target: h,
            identifier: b,
            active: L,
            x: w[0] + X,
            y: w[1] + Q,
            dx: w[0] - I[0],
            dy: w[1] - I[1],
            dispatch: R
          }),
          v
        );
      };
  }
  return h.filter = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Le(!!d), h) : t;
  }, h.container = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Le(d), h) : e;
  }, h.subject = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Le(d), h) : n;
  }, h.touchable = function(d) {
    return arguments.length ? (r = typeof d == "function" ? d : Le(!!d), h) : r;
  }, h.on = function() {
    var d = a.on.apply(a, arguments);
    return d === a ? h : d;
  }, h.clickDistance = function(d) {
    return arguments.length ? (f = (d = +d) * d, h) : Math.sqrt(f);
  }, h;
}
function _r(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function qi(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function Ie() {
}
var Pe = 0.7, ln = 1 / Pe, de = "\\s*([+-]?\\d+)\\s*", Ue = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Pt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Gs = /^#([0-9a-f]{3,8})$/, Qs = new RegExp(`^rgb\\(${de},${de},${de}\\)$`), Zs = new RegExp(`^rgb\\(${Pt},${Pt},${Pt}\\)$`), Ks = new RegExp(`^rgba\\(${de},${de},${de},${Ue}\\)$`), Js = new RegExp(`^rgba\\(${Pt},${Pt},${Pt},${Ue}\\)$`), js = new RegExp(`^hsl\\(${Ue},${Pt},${Pt}\\)$`), tu = new RegExp(`^hsla\\(${Ue},${Pt},${Pt},${Ue}\\)$`), Yr = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
_r(Ie, ee, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Ir,
  // Deprecated! Use color.formatHex.
  formatHex: Ir,
  formatHex8: eu,
  formatHsl: nu,
  formatRgb: Wr,
  toString: Wr
});
function Ir() {
  return this.rgb().formatHex();
}
function eu() {
  return this.rgb().formatHex8();
}
function nu() {
  return Bi(this).formatHsl();
}
function Wr() {
  return this.rgb().formatRgb();
}
function ee(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Gs.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? Rr(e) : n === 3 ? new wt(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? He(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? He(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = Qs.exec(t)) ? new wt(e[1], e[2], e[3], 1) : (e = Zs.exec(t)) ? new wt(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Ks.exec(t)) ? He(e[1], e[2], e[3], e[4]) : (e = Js.exec(t)) ? He(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = js.exec(t)) ? Hr(e[1], e[2] / 100, e[3] / 100, 1) : (e = tu.exec(t)) ? Hr(e[1], e[2] / 100, e[3] / 100, e[4]) : Yr.hasOwnProperty(t) ? Rr(Yr[t]) : t === "transparent" ? new wt(NaN, NaN, NaN, 0) : null;
}
function Rr(t) {
  return new wt(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function He(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new wt(t, e, n, r);
}
function ru(t) {
  return t instanceof Ie || (t = ee(t)), t ? (t = t.rgb(), new wt(t.r, t.g, t.b, t.opacity)) : new wt();
}
function Jn(t, e, n, r) {
  return arguments.length === 1 ? ru(t) : new wt(t, e, n, r ?? 1);
}
function wt(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
_r(wt, Jn, qi(Ie, {
  brighter(t) {
    return t = t == null ? ln : Math.pow(ln, t), new wt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Pe : Math.pow(Pe, t), new wt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new wt(Jt(this.r), Jt(this.g), Jt(this.b), cn(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: zr,
  // Deprecated! Use color.formatHex.
  formatHex: zr,
  formatHex8: iu,
  formatRgb: Lr,
  toString: Lr
}));
function zr() {
  return `#${Zt(this.r)}${Zt(this.g)}${Zt(this.b)}`;
}
function iu() {
  return `#${Zt(this.r)}${Zt(this.g)}${Zt(this.b)}${Zt((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Lr() {
  const t = cn(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Jt(this.r)}, ${Jt(this.g)}, ${Jt(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function cn(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Jt(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Zt(t) {
  return t = Jt(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Hr(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new kt(t, e, n, r);
}
function Bi(t) {
  if (t instanceof kt) return new kt(t.h, t.s, t.l, t.opacity);
  if (t instanceof Ie || (t = ee(t)), !t) return new kt();
  if (t instanceof kt) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), a = Math.max(e, n, r), o = NaN, s = a - i, l = (a + i) / 2;
  return s ? (e === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - e) / s + 2 : o = (e - n) / s + 4, s /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new kt(o, s, l, t.opacity);
}
function au(t, e, n, r) {
  return arguments.length === 1 ? Bi(t) : new kt(t, e, n, r ?? 1);
}
function kt(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
_r(kt, au, qi(Ie, {
  brighter(t) {
    return t = t == null ? ln : Math.pow(ln, t), new kt(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Pe : Math.pow(Pe, t), new kt(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new wt(
      On(t >= 240 ? t - 240 : t + 120, i, r),
      On(t, i, r),
      On(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new kt(Xr(this.h), Xe(this.s), Xe(this.l), cn(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = cn(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Xr(this.h)}, ${Xe(this.s) * 100}%, ${Xe(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Xr(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Xe(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function On(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const yr = (t) => () => t;
function ou(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function su(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function uu(t) {
  return (t = +t) == 1 ? Gi : function(e, n) {
    return n - e ? su(e, n, t) : yr(isNaN(e) ? n : e);
  };
}
function Gi(t, e) {
  var n = e - t;
  return n ? ou(t, n) : yr(isNaN(t) ? e : t);
}
const fn = (function t(e) {
  var n = uu(e);
  function r(i, a) {
    var o = n((i = Jn(i)).r, (a = Jn(a)).r), s = n(i.g, a.g), l = n(i.b, a.b), u = Gi(i.opacity, a.opacity);
    return function(c) {
      return i.r = o(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = t, r;
})(1);
function lu(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i) r[i] = t[i] * (1 - a) + e[i] * a;
    return r;
  };
}
function cu(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function fu(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = wr(t[o], e[o]);
  for (; o < n; ++o) a[o] = e[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function hu(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function St(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function du(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = wr(t[i], e[i]) : r[i] = e[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var jn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Fn = new RegExp(jn.source, "g");
function mu(t) {
  return function() {
    return t;
  };
}
function gu(t) {
  return function(e) {
    return t(e) + "";
  };
}
function Qi(t, e) {
  var n = jn.lastIndex = Fn.lastIndex = 0, r, i, a, o = -1, s = [], l = [];
  for (t = t + "", e = e + ""; (r = jn.exec(t)) && (i = Fn.exec(e)); )
    (a = i.index) > n && (a = e.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, l.push({ i: o, x: St(r, i) })), n = Fn.lastIndex;
  return n < e.length && (a = e.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? l[0] ? gu(l[0].x) : mu(e) : (e = l.length, function(u) {
    for (var c = 0, f; c < e; ++c) s[(f = l[c]).i] = f.x(u);
    return s.join("");
  });
}
function wr(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? yr(e) : (n === "number" ? St : n === "string" ? (r = ee(e)) ? (e = r, fn) : Qi : e instanceof ee ? fn : e instanceof Date ? hu : cu(e) ? lu : Array.isArray(e) ? fu : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? du : St)(t, e);
}
function vu(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var Vr = 180 / Math.PI, tr = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function Zi(t, e, n, r, i, a) {
  var o, s, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * n + e * r) && (n -= t * l, r -= e * l), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, l /= s), t * r < e * n && (t = -t, e = -e, l = -l, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(e, t) * Vr,
    skewX: Math.atan(l) * Vr,
    scaleX: o,
    scaleY: s
  };
}
var Ve;
function pu(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? tr : Zi(e.a, e.b, e.c, e.d, e.e, e.f);
}
function _u(t) {
  return t == null || (Ve || (Ve = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ve.setAttribute("transform", t), !(t = Ve.transform.baseVal.consolidate())) ? tr : (t = t.matrix, Zi(t.a, t.b, t.c, t.d, t.e, t.f));
}
function Ki(t, e, n, r) {
  function i(u) {
    return u.length ? u.pop() + " " : "";
  }
  function a(u, c, f, h, g, S) {
    if (u !== f || c !== h) {
      var M = g.push("translate(", null, e, null, n);
      S.push({ i: M - 4, x: St(u, f) }, { i: M - 2, x: St(c, h) });
    } else (f || h) && g.push("translate(" + f + e + h + n);
  }
  function o(u, c, f, h) {
    u !== c ? (u - c > 180 ? c += 360 : c - u > 180 && (u += 360), h.push({ i: f.push(i(f) + "rotate(", null, r) - 2, x: St(u, c) })) : c && f.push(i(f) + "rotate(" + c + r);
  }
  function s(u, c, f, h) {
    u !== c ? h.push({ i: f.push(i(f) + "skewX(", null, r) - 2, x: St(u, c) }) : c && f.push(i(f) + "skewX(" + c + r);
  }
  function l(u, c, f, h, g, S) {
    if (u !== f || c !== h) {
      var M = g.push(i(g) + "scale(", null, ",", null, ")");
      S.push({ i: M - 4, x: St(u, f) }, { i: M - 2, x: St(c, h) });
    } else (f !== 1 || h !== 1) && g.push(i(g) + "scale(" + f + "," + h + ")");
  }
  return function(u, c) {
    var f = [], h = [];
    return u = t(u), c = t(c), a(u.translateX, u.translateY, c.translateX, c.translateY, f, h), o(u.rotate, c.rotate, f, h), s(u.skewX, c.skewX, f, h), l(u.scaleX, u.scaleY, c.scaleX, c.scaleY, f, h), u = c = null, function(g) {
      for (var S = -1, M = h.length, A; ++S < M; ) f[(A = h[S]).i] = A.x(g);
      return f.join("");
    };
  };
}
var yu = Ki(pu, "px, ", "px)", "deg)"), wu = Ki(_u, ", ", ")", ")"), xu = 1e-12;
function qr(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function bu(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Mu(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const Tu = (function t(e, n, r) {
  function i(a, o) {
    var s = a[0], l = a[1], u = a[2], c = o[0], f = o[1], h = o[2], g = c - s, S = f - l, M = g * g + S * S, A, x;
    if (M < xu)
      x = Math.log(h / u) / e, A = function(v) {
        return [
          s + v * g,
          l + v * S,
          u * Math.exp(e * v * x)
        ];
      };
    else {
      var Y = Math.sqrt(M), $ = (h * h - u * u + r * M) / (2 * u * n * Y), d = (h * h - u * u - r * M) / (2 * h * n * Y), m = Math.log(Math.sqrt($ * $ + 1) - $), p = Math.log(Math.sqrt(d * d + 1) - d);
      x = (p - m) / e, A = function(v) {
        var b = v * x, C = qr(m), R = u / (n * Y) * (C * Mu(e * b + m) - bu(m));
        return [
          s + R * g,
          l + R * S,
          u * C / qr(e * b + m)
        ];
      };
    }
    return A.duration = x * 1e3 * e / Math.SQRT2, A;
  }
  return i.rho = function(a) {
    var o = Math.max(1e-3, +a), s = o * o, l = s * s;
    return t(o, s, l);
  }, i;
})(Math.SQRT2, 2, 4);
var ge = 0, $e = 0, we = 0, Ji = 1e3, hn, Ee, dn = 0, ne = 0, kn = 0, Oe = typeof performance == "object" && performance.now ? performance : Date, ji = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function xr() {
  return ne || (ji(Su), ne = Oe.now() + kn);
}
function Su() {
  ne = 0;
}
function mn() {
  this._call = this._time = this._next = null;
}
mn.prototype = ta.prototype = {
  constructor: mn,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? xr() : +n) + (e == null ? 0 : +e), !this._next && Ee !== this && (Ee ? Ee._next = this : hn = this, Ee = this), this._call = t, this._time = n, er();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, er());
  }
};
function ta(t, e, n) {
  var r = new mn();
  return r.restart(t, e, n), r;
}
function ku() {
  xr(), ++ge;
  for (var t = hn, e; t; )
    (e = ne - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --ge;
}
function Br() {
  ne = (dn = Oe.now()) + kn, ge = $e = 0;
  try {
    ku();
  } finally {
    ge = 0, Cu(), ne = 0;
  }
}
function Du() {
  var t = Oe.now(), e = t - dn;
  e > Ji && (kn -= e, dn = t);
}
function Cu() {
  for (var t, e = hn, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : hn = n);
  Ee = t, er(r);
}
function er(t) {
  if (!ge) {
    $e && ($e = clearTimeout($e));
    var e = t - ne;
    e > 24 ? (t < 1 / 0 && ($e = setTimeout(Br, t - Oe.now() - kn)), we && (we = clearInterval(we))) : (we || (dn = Oe.now(), we = setInterval(Du, Ji)), ge = 1, ji(Br));
  }
}
function Gr(t, e, n) {
  var r = new mn();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
var $u = Tn("start", "end", "cancel", "interrupt"), Eu = [], ea = 0, Qr = 1, nr = 2, en = 3, Zr = 4, rr = 5, nn = 6;
function Dn(t, e, n, r, i, a) {
  var o = t.__transition;
  if (!o) t.__transition = {};
  else if (n in o) return;
  Au(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: $u,
    tween: Eu,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: ea
  });
}
function br(t, e) {
  var n = Ct(t, e);
  if (n.state > ea) throw new Error("too late; already scheduled");
  return n;
}
function Ot(t, e) {
  var n = Ct(t, e);
  if (n.state > en) throw new Error("too late; already running");
  return n;
}
function Ct(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function Au(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = ta(a, 0, n.time);
  function a(u) {
    n.state = Qr, n.timer.restart(o, n.delay, n.time), n.delay <= u && o(u - n.delay);
  }
  function o(u) {
    var c, f, h, g;
    if (n.state !== Qr) return l();
    for (c in r)
      if (g = r[c], g.name === n.name) {
        if (g.state === en) return Gr(o);
        g.state === Zr ? (g.state = nn, g.timer.stop(), g.on.call("interrupt", t, t.__data__, g.index, g.group), delete r[c]) : +c < e && (g.state = nn, g.timer.stop(), g.on.call("cancel", t, t.__data__, g.index, g.group), delete r[c]);
      }
    if (Gr(function() {
      n.state === en && (n.state = Zr, n.timer.restart(s, n.delay, n.time), s(u));
    }), n.state = nr, n.on.call("start", t, t.__data__, n.index, n.group), n.state === nr) {
      for (n.state = en, i = new Array(h = n.tween.length), c = 0, f = -1; c < h; ++c)
        (g = n.tween[c].value.call(t, t.__data__, n.index, n.group)) && (i[++f] = g);
      i.length = f + 1;
    }
  }
  function s(u) {
    for (var c = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(l), n.state = rr, 1), f = -1, h = i.length; ++f < h; )
      i[f].call(t, c);
    n.state === rr && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = nn, n.timer.stop(), delete r[e];
    for (var u in r) return;
    delete t.__transition;
  }
}
function rn(t, e) {
  var n = t.__transition, r, i, a = !0, o;
  if (n) {
    e = e == null ? null : e + "";
    for (o in n) {
      if ((r = n[o]).name !== e) {
        a = !1;
        continue;
      }
      i = r.state > nr && r.state < rr, r.state = nn, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[o];
    }
    a && delete t.__transition;
  }
}
function Nu(t) {
  return this.each(function() {
    rn(this, t);
  });
}
function Pu(t, e) {
  var n, r;
  return function() {
    var i = Ot(this, t), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === e) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function Uu(t, e, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var a = Ot(this, t), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: e, value: n }, l = 0, u = i.length; l < u; ++l)
        if (i[l].name === e) {
          i[l] = s;
          break;
        }
      l === u && i.push(s);
    }
    a.tween = i;
  };
}
function Ou(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = Ct(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? Pu : Uu)(n, t, e));
}
function Mr(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = Ot(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return Ct(i, r).value[e];
  };
}
function na(t, e) {
  var n;
  return (typeof e == "number" ? St : e instanceof ee ? fn : (n = ee(e)) ? (e = n, fn) : Qi)(t, e);
}
function Fu(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Yu(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Iu(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttribute(t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Wu(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Ru(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function zu(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), l;
    return s == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), l = s + "", o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s)));
  };
}
function Lu(t, e) {
  var n = Sn(t), r = n === "transform" ? wu : na;
  return this.attrTween(t, typeof e == "function" ? (n.local ? zu : Ru)(n, r, Mr(this, "attr." + t, e)) : e == null ? (n.local ? Yu : Fu)(n) : (n.local ? Wu : Iu)(n, r, e));
}
function Hu(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function Xu(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function Vu(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && Xu(t, a)), n;
  }
  return i._value = e, i;
}
function qu(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && Hu(t, a)), n;
  }
  return i._value = e, i;
}
function Bu(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = Sn(t);
  return this.tween(n, (r.local ? Vu : qu)(r, e));
}
function Gu(t, e) {
  return function() {
    br(this, t).delay = +e.apply(this, arguments);
  };
}
function Qu(t, e) {
  return e = +e, function() {
    br(this, t).delay = e;
  };
}
function Zu(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Gu : Qu)(e, t)) : Ct(this.node(), e).delay;
}
function Ku(t, e) {
  return function() {
    Ot(this, t).duration = +e.apply(this, arguments);
  };
}
function Ju(t, e) {
  return e = +e, function() {
    Ot(this, t).duration = e;
  };
}
function ju(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Ku : Ju)(e, t)) : Ct(this.node(), e).duration;
}
function tl(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    Ot(this, t).ease = e;
  };
}
function el(t) {
  var e = this._id;
  return arguments.length ? this.each(tl(e, t)) : Ct(this.node(), e).ease;
}
function nl(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Ot(this, t).ease = n;
  };
}
function rl(t) {
  if (typeof t != "function") throw new Error();
  return this.each(nl(this._id, t));
}
function il(t) {
  typeof t != "function" && (t = Ui(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], l, u = 0; u < o; ++u)
      (l = a[u]) && t.call(l, l.__data__, u, a) && s.push(l);
  return new Lt(r, this._parents, this._name, this._id);
}
function al(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var l = e[s], u = n[s], c = l.length, f = o[s] = new Array(c), h, g = 0; g < c; ++g)
      (h = l[g] || u[g]) && (f[g] = h);
  for (; s < r; ++s)
    o[s] = e[s];
  return new Lt(o, this._parents, this._name, this._id);
}
function ol(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function sl(t, e, n) {
  var r, i, a = ol(e) ? br : Ot;
  return function() {
    var o = a(this, t), s = o.on;
    s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
  };
}
function ul(t, e) {
  var n = this._id;
  return arguments.length < 2 ? Ct(this.node(), n).on.on(t) : this.each(sl(n, t, e));
}
function ll(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function cl() {
  return this.on("end.remove", ll(this._id));
}
function fl(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = vr(t));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], l = s.length, u = a[o] = new Array(l), c, f, h = 0; h < l; ++h)
      (c = s[h]) && (f = t.call(c, c.__data__, h, s)) && ("__data__" in c && (f.__data__ = c.__data__), u[h] = f, Dn(u[h], e, n, h, u, Ct(c, n)));
  return new Lt(a, this._parents, e, n);
}
function hl(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Pi(t));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var l = r[s], u = l.length, c, f = 0; f < u; ++f)
      if (c = l[f]) {
        for (var h = t.call(c, c.__data__, f, l), g, S = Ct(c, n), M = 0, A = h.length; M < A; ++M)
          (g = h[M]) && Dn(g, e, n, M, h, S);
        a.push(h), o.push(c);
      }
  return new Lt(a, o, e, n);
}
var dl = Ye.prototype.constructor;
function ml() {
  return new dl(this._groups, this._parents);
}
function gl(t, e) {
  var n, r, i;
  return function() {
    var a = me(this, t), o = (this.style.removeProperty(t), me(this, t));
    return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
  };
}
function ra(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function vl(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = me(this, t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function pl(t, e, n) {
  var r, i, a;
  return function() {
    var o = me(this, t), s = n(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(t), me(this, t))), o === l ? null : o === r && l === i ? a : (i = l, a = e(r = o, s));
  };
}
function _l(t, e) {
  var n, r, i, a = "style." + e, o = "end." + a, s;
  return function() {
    var l = Ot(this, t), u = l.on, c = l.value[a] == null ? s || (s = ra(e)) : void 0;
    (u !== n || i !== c) && (r = (n = u).copy()).on(o, i = c), l.on = r;
  };
}
function yl(t, e, n) {
  var r = (t += "") == "transform" ? yu : na;
  return e == null ? this.styleTween(t, gl(t, r)).on("end.style." + t, ra(t)) : typeof e == "function" ? this.styleTween(t, pl(t, r, Mr(this, "style." + t, e))).each(_l(this._id, t)) : this.styleTween(t, vl(t, r, e), n).on("end.style." + t, null);
}
function wl(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function xl(t, e, n) {
  var r, i;
  function a() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && wl(t, o, n)), r;
  }
  return a._value = e, a;
}
function bl(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, xl(t, e, n ?? ""));
}
function Ml(t) {
  return function() {
    this.textContent = t;
  };
}
function Tl(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function Sl(t) {
  return this.tween("text", typeof t == "function" ? Tl(Mr(this, "text", t)) : Ml(t == null ? "" : t + ""));
}
function kl(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Dl(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && kl(i)), e;
  }
  return r._value = t, r;
}
function Cl(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, Dl(t));
}
function $l() {
  for (var t = this._name, e = this._id, n = ia(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, u = 0; u < s; ++u)
      if (l = o[u]) {
        var c = Ct(l, e);
        Dn(l, t, n, u, o, {
          time: c.time + c.delay + c.duration,
          delay: 0,
          duration: c.duration,
          ease: c.ease
        });
      }
  return new Lt(r, this._parents, t, n);
}
function El() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(a, o) {
    var s = { value: o }, l = { value: function() {
      --i === 0 && a();
    } };
    n.each(function() {
      var u = Ot(this, r), c = u.on;
      c !== t && (e = (t = c).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), u.on = e;
    }), i === 0 && a();
  });
}
var Al = 0;
function Lt(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function ia() {
  return ++Al;
}
var It = Ye.prototype;
Lt.prototype = {
  constructor: Lt,
  select: fl,
  selectAll: hl,
  selectChild: It.selectChild,
  selectChildren: It.selectChildren,
  filter: il,
  merge: al,
  selection: ml,
  transition: $l,
  call: It.call,
  nodes: It.nodes,
  node: It.node,
  size: It.size,
  empty: It.empty,
  each: It.each,
  on: ul,
  attr: Lu,
  attrTween: Bu,
  style: yl,
  styleTween: bl,
  text: Sl,
  textTween: Cl,
  remove: cl,
  tween: Ou,
  delay: Zu,
  duration: ju,
  ease: el,
  easeVarying: rl,
  end: El,
  [Symbol.iterator]: It[Symbol.iterator]
};
function Nl(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var Pl = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Nl
};
function Ul(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function Ol(t) {
  var e, n;
  t instanceof Lt ? (e = t._id, t = t._name) : (e = ia(), (n = Pl).time = xr(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, l, u = 0; u < s; ++u)
      (l = o[u]) && Dn(l, t, e, u, o, n || Ul(l, e));
  return new Lt(r, this._parents, t, e);
}
Ye.prototype.interrupt = Nu;
Ye.prototype.transition = Ol;
const ir = Math.PI, ar = 2 * ir, Gt = 1e-6, Fl = ar - Gt;
function or() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function aa() {
  return new or();
}
or.prototype = aa.prototype = {
  constructor: or,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, i, a) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - t, l = r - e, u = a - t, c = o - e, f = u * u + c * c;
    if (i < 0) throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (f > Gt) if (!(Math.abs(c * s - l * u) > Gt) || !i)
      this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
    else {
      var h = n - a, g = r - o, S = s * s + l * l, M = h * h + g * g, A = Math.sqrt(S), x = Math.sqrt(f), Y = i * Math.tan((ir - Math.acos((S + f - M) / (2 * A * x))) / 2), $ = Y / x, d = Y / A;
      Math.abs($ - 1) > Gt && (this._ += "L" + (t + $ * u) + "," + (e + $ * c)), this._ += "A" + i + "," + i + ",0,0," + +(c * h > u * g) + "," + (this._x1 = t + d * s) + "," + (this._y1 = e + d * l);
    }
  },
  arc: function(t, e, n, r, i, a) {
    t = +t, e = +e, n = +n, a = !!a;
    var o = n * Math.cos(r), s = n * Math.sin(r), l = t + o, u = e + s, c = 1 ^ a, f = a ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + l + "," + u : (Math.abs(this._x1 - l) > Gt || Math.abs(this._y1 - u) > Gt) && (this._ += "L" + l + "," + u), n && (f < 0 && (f = f % ar + ar), f > Fl ? this._ += "A" + n + "," + n + ",0,1," + c + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + c + "," + (this._x1 = l) + "," + (this._y1 = u) : f > Gt && (this._ += "A" + n + "," + n + ",0," + +(f >= ir) + "," + c + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function Yl(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function gn(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function ve(t) {
  return t = gn(Math.abs(t)), t ? t[1] : NaN;
}
function Il(t, e) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = t[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = t[o = (o + 1) % t.length];
    return a.reverse().join(e);
  };
}
function Wl(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var Rl = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function vn(t) {
  if (!(e = Rl.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new Tr({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
vn.prototype = Tr.prototype;
function Tr(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Tr.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function zl(t) {
  t: for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+t[n]) break t;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var oa;
function Ll(t, e) {
  var n = gn(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1], a = i - (oa = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + gn(t, Math.max(0, e + a - 1))[0];
}
function Kr(t, e) {
  var n = gn(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Jr = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: Yl,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Kr(t * 100, e),
  r: Kr,
  s: Ll,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function jr(t) {
  return t;
}
var ti = Array.prototype.map, ei = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Hl(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? jr : Il(ti.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? jr : Wl(ti.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function u(f) {
    f = vn(f);
    var h = f.fill, g = f.align, S = f.sign, M = f.symbol, A = f.zero, x = f.width, Y = f.comma, $ = f.precision, d = f.trim, m = f.type;
    m === "n" ? (Y = !0, m = "g") : Jr[m] || ($ === void 0 && ($ = 12), d = !0, m = "g"), (A || h === "0" && g === "=") && (A = !0, h = "0", g = "=");
    var p = M === "$" ? n : M === "#" && /[boxX]/.test(m) ? "0" + m.toLowerCase() : "", v = M === "$" ? r : /[%p]/.test(m) ? o : "", b = Jr[m], C = /[defgprs%]/.test(m);
    $ = $ === void 0 ? 6 : /[gprs]/.test(m) ? Math.max(1, Math.min(21, $)) : Math.max(0, Math.min(20, $));
    function R(w) {
      var X = p, Q = v, _, P, y;
      if (m === "c")
        Q = b(w) + Q, w = "";
      else {
        w = +w;
        var O = w < 0 || 1 / w < 0;
        if (w = isNaN(w) ? l : b(Math.abs(w), $), d && (w = zl(w)), O && +w == 0 && S !== "+" && (O = !1), X = (O ? S === "(" ? S : s : S === "-" || S === "(" ? "" : S) + X, Q = (m === "s" ? ei[8 + oa / 3] : "") + Q + (O && S === "(" ? ")" : ""), C) {
          for (_ = -1, P = w.length; ++_ < P; )
            if (y = w.charCodeAt(_), 48 > y || y > 57) {
              Q = (y === 46 ? i + w.slice(_ + 1) : w.slice(_)) + Q, w = w.slice(0, _);
              break;
            }
        }
      }
      Y && !A && (w = e(w, 1 / 0));
      var W = X.length + w.length + Q.length, I = W < x ? new Array(x - W + 1).join(h) : "";
      switch (Y && A && (w = e(I + w, I.length ? x - Q.length : 1 / 0), I = ""), g) {
        case "<":
          w = X + w + Q + I;
          break;
        case "=":
          w = X + I + w + Q;
          break;
        case "^":
          w = I.slice(0, W = I.length >> 1) + X + w + Q + I.slice(W);
          break;
        default:
          w = I + X + w + Q;
          break;
      }
      return a(w);
    }
    return R.toString = function() {
      return f + "";
    }, R;
  }
  function c(f, h) {
    var g = u((f = vn(f), f.type = "f", f)), S = Math.max(-8, Math.min(8, Math.floor(ve(h) / 3))) * 3, M = Math.pow(10, -S), A = ei[8 + S / 3];
    return function(x) {
      return g(M * x) + A;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var qe, Sr, sa;
Xl({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Xl(t) {
  return qe = Hl(t), Sr = qe.format, sa = qe.formatPrefix, qe;
}
function Vl(t) {
  return Math.max(0, -ve(Math.abs(t)));
}
function ql(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ve(e) / 3))) * 3 - ve(Math.abs(t)));
}
function Bl(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, ve(e) - ve(t)) + 1;
}
function ua(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function Gl(t) {
  return function() {
    return t;
  };
}
function Ql(t) {
  return +t;
}
var ni = [0, 1];
function fe(t) {
  return t;
}
function sr(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : Gl(isNaN(e) ? NaN : 0.5);
}
function Zl(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function Kl(t, e, n) {
  var r = t[0], i = t[1], a = e[0], o = e[1];
  return i < r ? (r = sr(i, r), a = n(o, a)) : (r = sr(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function Jl(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = sr(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
  return function(s) {
    var l = qa(t, s, 1, r) - 1;
    return a[l](i[l](s));
  };
}
function la(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function jl() {
  var t = ni, e = ni, n = wr, r, i, a, o = fe, s, l, u;
  function c() {
    var h = Math.min(t.length, e.length);
    return o !== fe && (o = Zl(t[0], t[h - 1])), s = h > 2 ? Jl : Kl, l = u = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? a : (l || (l = s(t.map(r), e, n)))(r(o(h)));
  }
  return f.invert = function(h) {
    return o(i((u || (u = s(e, t.map(r), St)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (t = Array.from(h, Ql), c()) : t.slice();
  }, f.range = function(h) {
    return arguments.length ? (e = Array.from(h), c()) : e.slice();
  }, f.rangeRound = function(h) {
    return e = Array.from(h), n = vu, c();
  }, f.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : fe, c()) : o !== fe;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, c()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (a = h, f) : a;
  }, function(h, g) {
    return r = h, i = g, c();
  };
}
function ca() {
  return jl()(fe, fe);
}
function tc(t, e, n, r) {
  var i = Gn(t, e, n), a;
  switch (r = vn(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(a = ql(i, o)) && (r.precision = a), sa(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = Bl(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = Vl(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Sr(r);
}
function ec(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return Za(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return tc(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, a = r.length - 1, o = r[i], s = r[a], l, u, c = 10;
    for (s < o && (u = o, o = s, s = u, u = i, i = a, a = u); c-- > 0; ) {
      if (u = Bn(o, s, n), u === l)
        return r[i] = o, r[a] = s, e(r);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      l = u;
    }
    return t;
  }, t;
}
function Ht() {
  var t = ca();
  return t.copy = function() {
    return la(t, Ht());
  }, ua.apply(t, arguments), ec(t);
}
function nc(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], a = t[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), t[n] = e.floor(i), t[r] = e.ceil(a), t;
}
var Yn = /* @__PURE__ */ new Date(), In = /* @__PURE__ */ new Date();
function yt(t, e, n, r) {
  function i(a) {
    return t(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = function(a) {
    return t(a = /* @__PURE__ */ new Date(+a)), a;
  }, i.ceil = function(a) {
    return t(a = new Date(a - 1)), e(a, 1), t(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return e(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var l = [], u;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return l;
    do
      l.push(u = /* @__PURE__ */ new Date(+a)), e(a, s), t(a);
    while (u < a && a < o);
    return l;
  }, i.filter = function(a) {
    return yt(function(o) {
      if (o >= o) for (; t(o), !a(o); ) o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0) for (; ++s <= 0; )
          for (; e(o, -1), !a(o); )
            ;
        else for (; --s >= 0; )
          for (; e(o, 1), !a(o); )
            ;
    });
  }, n && (i.count = function(a, o) {
    return Yn.setTime(+a), In.setTime(+o), t(Yn), t(In), Math.floor(n(Yn, In));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var pn = yt(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
pn.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? yt(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : pn;
};
pn.range;
const Wt = 1e3, Nt = Wt * 60, Kt = Nt * 60, re = Kt * 24, kr = re * 7, ri = re * 30, Wn = re * 365;
var qt = yt(function(t) {
  t.setTime(t - t.getMilliseconds());
}, function(t, e) {
  t.setTime(+t + e * Wt);
}, function(t, e) {
  return (e - t) / Wt;
}, function(t) {
  return t.getUTCSeconds();
});
qt.range;
var We = yt(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Wt);
}, function(t, e) {
  t.setTime(+t + e * Nt);
}, function(t, e) {
  return (e - t) / Nt;
}, function(t) {
  return t.getMinutes();
});
We.range;
var Re = yt(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Wt - t.getMinutes() * Nt);
}, function(t, e) {
  t.setTime(+t + e * Kt);
}, function(t, e) {
  return (e - t) / Kt;
}, function(t) {
  return t.getHours();
});
Re.range;
var ae = yt(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Nt) / re,
  (t) => t.getDate() - 1
);
ae.range;
function oe(t) {
  return yt(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * Nt) / kr;
  });
}
var ze = oe(0), _n = oe(1), rc = oe(2), ic = oe(3), pe = oe(4), ac = oe(5), oc = oe(6);
ze.range;
_n.range;
rc.range;
ic.range;
pe.range;
ac.range;
oc.range;
var Cn = yt(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
});
Cn.range;
var Dt = yt(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
Dt.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : yt(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
Dt.range;
var Dr = yt(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / re;
}, function(t) {
  return t.getUTCDate() - 1;
});
Dr.range;
function se(t) {
  return yt(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / kr;
  });
}
var fa = se(0), yn = se(1), sc = se(2), uc = se(3), _e = se(4), lc = se(5), cc = se(6);
fa.range;
yn.range;
sc.range;
uc.range;
_e.range;
lc.range;
cc.range;
var ie = yt(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
ie.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : yt(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
ie.range;
function fc(t, e, n, r, i, a) {
  const o = [
    [qt, 1, Wt],
    [qt, 5, 5 * Wt],
    [qt, 15, 15 * Wt],
    [qt, 30, 30 * Wt],
    [a, 1, Nt],
    [a, 5, 5 * Nt],
    [a, 15, 15 * Nt],
    [a, 30, 30 * Nt],
    [i, 1, Kt],
    [i, 3, 3 * Kt],
    [i, 6, 6 * Kt],
    [i, 12, 12 * Kt],
    [r, 1, re],
    [r, 2, 2 * re],
    [n, 1, kr],
    [e, 1, ri],
    [e, 3, 3 * ri],
    [t, 1, Wn]
  ];
  function s(u, c, f) {
    const h = c < u;
    h && ([u, c] = [c, u]);
    const g = f && typeof f.range == "function" ? f : l(u, c, f), S = g ? g.range(u, +c + 1) : [];
    return h ? S.reverse() : S;
  }
  function l(u, c, f) {
    const h = Math.abs(c - u) / f, g = mr(([, , A]) => A).right(o, h);
    if (g === o.length) return t.every(Gn(u / Wn, c / Wn, f));
    if (g === 0) return pn.every(Math.max(Gn(u, c, f), 1));
    const [S, M] = o[h / o[g - 1][2] < o[g][2] / h ? g - 1 : g];
    return S.every(M);
  }
  return [s, l];
}
const [hc, dc] = fc(Dt, Cn, ze, ae, Re, We);
function Rn(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function zn(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function xe(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function mc(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, a = t.days, o = t.shortDays, s = t.months, l = t.shortMonths, u = be(i), c = Me(i), f = be(a), h = Me(a), g = be(o), S = Me(o), M = be(s), A = Me(s), x = be(l), Y = Me(l), $ = {
    a: O,
    A: W,
    b: I,
    B: L,
    c: null,
    d: li,
    e: li,
    f: Yc,
    g: Bc,
    G: Qc,
    H: Uc,
    I: Oc,
    j: Fc,
    L: ha,
    m: Ic,
    M: Wc,
    p: k,
    q: U,
    Q: hi,
    s: di,
    S: Rc,
    u: zc,
    U: Lc,
    V: Hc,
    w: Xc,
    W: Vc,
    x: null,
    X: null,
    y: qc,
    Y: Gc,
    Z: Zc,
    "%": fi
  }, d = {
    a: q,
    A: V,
    b: st,
    B: at,
    c: null,
    d: ci,
    e: ci,
    f: tf,
    g: ff,
    G: df,
    H: Kc,
    I: Jc,
    j: jc,
    L: ma,
    m: ef,
    M: nf,
    p: J,
    q: ut,
    Q: hi,
    s: di,
    S: rf,
    u: af,
    U: of,
    V: sf,
    w: uf,
    W: lf,
    x: null,
    X: null,
    y: cf,
    Y: hf,
    Z: mf,
    "%": fi
  }, m = {
    a: R,
    A: w,
    b: X,
    B: Q,
    c: _,
    d: si,
    e: si,
    f: Ec,
    g: oi,
    G: ai,
    H: ui,
    I: ui,
    j: kc,
    L: $c,
    m: Sc,
    M: Dc,
    p: C,
    q: Tc,
    Q: Nc,
    s: Pc,
    S: Cc,
    u: yc,
    U: wc,
    V: xc,
    w: _c,
    W: bc,
    x: P,
    X: y,
    y: oi,
    Y: ai,
    Z: Mc,
    "%": Ac
  };
  $.x = p(n, $), $.X = p(r, $), $.c = p(e, $), d.x = p(n, d), d.X = p(r, d), d.c = p(e, d);
  function p(N, Z) {
    return function(j) {
      var T = [], mt = -1, rt = 0, E = N.length, H, z, et;
      for (j instanceof Date || (j = /* @__PURE__ */ new Date(+j)); ++mt < E; )
        N.charCodeAt(mt) === 37 && (T.push(N.slice(rt, mt)), (z = ii[H = N.charAt(++mt)]) != null ? H = N.charAt(++mt) : z = H === "e" ? " " : "0", (et = Z[H]) && (H = et(j, z)), T.push(H), rt = mt + 1);
      return T.push(N.slice(rt, mt)), T.join("");
    };
  }
  function v(N, Z) {
    return function(j) {
      var T = xe(1900, void 0, 1), mt = b(T, N, j += "", 0), rt, E;
      if (mt != j.length) return null;
      if ("Q" in T) return new Date(T.Q);
      if ("s" in T) return new Date(T.s * 1e3 + ("L" in T ? T.L : 0));
      if (Z && !("Z" in T) && (T.Z = 0), "p" in T && (T.H = T.H % 12 + T.p * 12), T.m === void 0 && (T.m = "q" in T ? T.q : 0), "V" in T) {
        if (T.V < 1 || T.V > 53) return null;
        "w" in T || (T.w = 1), "Z" in T ? (rt = zn(xe(T.y, 0, 1)), E = rt.getUTCDay(), rt = E > 4 || E === 0 ? yn.ceil(rt) : yn(rt), rt = Dr.offset(rt, (T.V - 1) * 7), T.y = rt.getUTCFullYear(), T.m = rt.getUTCMonth(), T.d = rt.getUTCDate() + (T.w + 6) % 7) : (rt = Rn(xe(T.y, 0, 1)), E = rt.getDay(), rt = E > 4 || E === 0 ? _n.ceil(rt) : _n(rt), rt = ae.offset(rt, (T.V - 1) * 7), T.y = rt.getFullYear(), T.m = rt.getMonth(), T.d = rt.getDate() + (T.w + 6) % 7);
      } else ("W" in T || "U" in T) && ("w" in T || (T.w = "u" in T ? T.u % 7 : "W" in T ? 1 : 0), E = "Z" in T ? zn(xe(T.y, 0, 1)).getUTCDay() : Rn(xe(T.y, 0, 1)).getDay(), T.m = 0, T.d = "W" in T ? (T.w + 6) % 7 + T.W * 7 - (E + 5) % 7 : T.w + T.U * 7 - (E + 6) % 7);
      return "Z" in T ? (T.H += T.Z / 100 | 0, T.M += T.Z % 100, zn(T)) : Rn(T);
    };
  }
  function b(N, Z, j, T) {
    for (var mt = 0, rt = Z.length, E = j.length, H, z; mt < rt; ) {
      if (T >= E) return -1;
      if (H = Z.charCodeAt(mt++), H === 37) {
        if (H = Z.charAt(mt++), z = m[H in ii ? Z.charAt(mt++) : H], !z || (T = z(N, j, T)) < 0) return -1;
      } else if (H != j.charCodeAt(T++))
        return -1;
    }
    return T;
  }
  function C(N, Z, j) {
    var T = u.exec(Z.slice(j));
    return T ? (N.p = c.get(T[0].toLowerCase()), j + T[0].length) : -1;
  }
  function R(N, Z, j) {
    var T = g.exec(Z.slice(j));
    return T ? (N.w = S.get(T[0].toLowerCase()), j + T[0].length) : -1;
  }
  function w(N, Z, j) {
    var T = f.exec(Z.slice(j));
    return T ? (N.w = h.get(T[0].toLowerCase()), j + T[0].length) : -1;
  }
  function X(N, Z, j) {
    var T = x.exec(Z.slice(j));
    return T ? (N.m = Y.get(T[0].toLowerCase()), j + T[0].length) : -1;
  }
  function Q(N, Z, j) {
    var T = M.exec(Z.slice(j));
    return T ? (N.m = A.get(T[0].toLowerCase()), j + T[0].length) : -1;
  }
  function _(N, Z, j) {
    return b(N, e, Z, j);
  }
  function P(N, Z, j) {
    return b(N, n, Z, j);
  }
  function y(N, Z, j) {
    return b(N, r, Z, j);
  }
  function O(N) {
    return o[N.getDay()];
  }
  function W(N) {
    return a[N.getDay()];
  }
  function I(N) {
    return l[N.getMonth()];
  }
  function L(N) {
    return s[N.getMonth()];
  }
  function k(N) {
    return i[+(N.getHours() >= 12)];
  }
  function U(N) {
    return 1 + ~~(N.getMonth() / 3);
  }
  function q(N) {
    return o[N.getUTCDay()];
  }
  function V(N) {
    return a[N.getUTCDay()];
  }
  function st(N) {
    return l[N.getUTCMonth()];
  }
  function at(N) {
    return s[N.getUTCMonth()];
  }
  function J(N) {
    return i[+(N.getUTCHours() >= 12)];
  }
  function ut(N) {
    return 1 + ~~(N.getUTCMonth() / 3);
  }
  return {
    format: function(N) {
      var Z = p(N += "", $);
      return Z.toString = function() {
        return N;
      }, Z;
    },
    parse: function(N) {
      var Z = v(N += "", !1);
      return Z.toString = function() {
        return N;
      }, Z;
    },
    utcFormat: function(N) {
      var Z = p(N += "", d);
      return Z.toString = function() {
        return N;
      }, Z;
    },
    utcParse: function(N) {
      var Z = v(N += "", !0);
      return Z.toString = function() {
        return N;
      }, Z;
    }
  };
}
var ii = { "-": "", _: " ", 0: "0" }, dt = /^\s*\d+/, gc = /^%/, vc = /[\\^$*+?|[\]().{}]/g;
function tt(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
}
function pc(t) {
  return t.replace(vc, "\\$&");
}
function be(t) {
  return new RegExp("^(?:" + t.map(pc).join("|") + ")", "i");
}
function Me(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function _c(t, e, n) {
  var r = dt.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function yc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function wc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function xc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function bc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function ai(t, e, n) {
  var r = dt.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function oi(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Mc(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function Tc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function Sc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function si(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function kc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function ui(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function Dc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function Cc(t, e, n) {
  var r = dt.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function $c(t, e, n) {
  var r = dt.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function Ec(t, e, n) {
  var r = dt.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Ac(t, e, n) {
  var r = gc.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Nc(t, e, n) {
  var r = dt.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function Pc(t, e, n) {
  var r = dt.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function li(t, e) {
  return tt(t.getDate(), e, 2);
}
function Uc(t, e) {
  return tt(t.getHours(), e, 2);
}
function Oc(t, e) {
  return tt(t.getHours() % 12 || 12, e, 2);
}
function Fc(t, e) {
  return tt(1 + ae.count(Dt(t), t), e, 3);
}
function ha(t, e) {
  return tt(t.getMilliseconds(), e, 3);
}
function Yc(t, e) {
  return ha(t, e) + "000";
}
function Ic(t, e) {
  return tt(t.getMonth() + 1, e, 2);
}
function Wc(t, e) {
  return tt(t.getMinutes(), e, 2);
}
function Rc(t, e) {
  return tt(t.getSeconds(), e, 2);
}
function zc(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function Lc(t, e) {
  return tt(ze.count(Dt(t) - 1, t), e, 2);
}
function da(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? pe(t) : pe.ceil(t);
}
function Hc(t, e) {
  return t = da(t), tt(pe.count(Dt(t), t) + (Dt(t).getDay() === 4), e, 2);
}
function Xc(t) {
  return t.getDay();
}
function Vc(t, e) {
  return tt(_n.count(Dt(t) - 1, t), e, 2);
}
function qc(t, e) {
  return tt(t.getFullYear() % 100, e, 2);
}
function Bc(t, e) {
  return t = da(t), tt(t.getFullYear() % 100, e, 2);
}
function Gc(t, e) {
  return tt(t.getFullYear() % 1e4, e, 4);
}
function Qc(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? pe(t) : pe.ceil(t), tt(t.getFullYear() % 1e4, e, 4);
}
function Zc(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + tt(e / 60 | 0, "0", 2) + tt(e % 60, "0", 2);
}
function ci(t, e) {
  return tt(t.getUTCDate(), e, 2);
}
function Kc(t, e) {
  return tt(t.getUTCHours(), e, 2);
}
function Jc(t, e) {
  return tt(t.getUTCHours() % 12 || 12, e, 2);
}
function jc(t, e) {
  return tt(1 + Dr.count(ie(t), t), e, 3);
}
function ma(t, e) {
  return tt(t.getUTCMilliseconds(), e, 3);
}
function tf(t, e) {
  return ma(t, e) + "000";
}
function ef(t, e) {
  return tt(t.getUTCMonth() + 1, e, 2);
}
function nf(t, e) {
  return tt(t.getUTCMinutes(), e, 2);
}
function rf(t, e) {
  return tt(t.getUTCSeconds(), e, 2);
}
function af(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function of(t, e) {
  return tt(fa.count(ie(t) - 1, t), e, 2);
}
function ga(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? _e(t) : _e.ceil(t);
}
function sf(t, e) {
  return t = ga(t), tt(_e.count(ie(t), t) + (ie(t).getUTCDay() === 4), e, 2);
}
function uf(t) {
  return t.getUTCDay();
}
function lf(t, e) {
  return tt(yn.count(ie(t) - 1, t), e, 2);
}
function cf(t, e) {
  return tt(t.getUTCFullYear() % 100, e, 2);
}
function ff(t, e) {
  return t = ga(t), tt(t.getUTCFullYear() % 100, e, 2);
}
function hf(t, e) {
  return tt(t.getUTCFullYear() % 1e4, e, 4);
}
function df(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? _e(t) : _e.ceil(t), tt(t.getUTCFullYear() % 1e4, e, 4);
}
function mf() {
  return "+0000";
}
function fi() {
  return "%";
}
function hi(t) {
  return +t;
}
function di(t) {
  return Math.floor(+t / 1e3);
}
var ue, Ft;
gf({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function gf(t) {
  return ue = mc(t), Ft = ue.format, ue.parse, ue.utcFormat, ue.utcParse, ue;
}
function vf(t) {
  return new Date(t);
}
function pf(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function va(t, e, n, r, i, a, o, s, l, u) {
  var c = ca(), f = c.invert, h = c.domain, g = u(".%L"), S = u(":%S"), M = u("%I:%M"), A = u("%I %p"), x = u("%a %d"), Y = u("%b %d"), $ = u("%B"), d = u("%Y");
  function m(p) {
    return (l(p) < p ? g : s(p) < p ? S : o(p) < p ? M : a(p) < p ? A : r(p) < p ? i(p) < p ? x : Y : n(p) < p ? $ : d)(p);
  }
  return c.invert = function(p) {
    return new Date(f(p));
  }, c.domain = function(p) {
    return arguments.length ? h(Array.from(p, pf)) : h().map(vf);
  }, c.ticks = function(p) {
    var v = h();
    return t(v[0], v[v.length - 1], p ?? 10);
  }, c.tickFormat = function(p, v) {
    return v == null ? m : u(v);
  }, c.nice = function(p) {
    var v = h();
    return (!p || typeof p.range != "function") && (p = e(v[0], v[v.length - 1], p ?? 10)), p ? h(nc(v, p)) : c;
  }, c.copy = function() {
    return la(c, va(t, e, n, r, i, a, o, s, l, u));
  }, c;
}
function xt() {
  return ua.apply(va(hc, dc, Dt, Cn, ze, ae, Re, We, qt, Ft).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Et(t) {
  return function() {
    return t;
  };
}
const mi = 1e-12;
function pa(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function _a(t) {
  this._context = t;
}
_a.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function _f(t) {
  return new _a(t);
}
function yf(t) {
  return t[0];
}
function wf(t) {
  return t[1];
}
function ya(t, e) {
  var n = Et(!0), r = null, i = _f, a = null;
  t = typeof t == "function" ? t : t === void 0 ? yf : Et(t), e = typeof e == "function" ? e : e === void 0 ? wf : Et(e);
  function o(s) {
    var l, u = (s = pa(s)).length, c, f = !1, h;
    for (r == null && (a = i(h = aa())), l = 0; l <= u; ++l)
      !(l < u && n(c = s[l], l, s)) === f && ((f = !f) ? a.lineStart() : a.lineEnd()), f && a.point(+t(c, l, s), +e(c, l, s));
    if (h) return a = null, h + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Et(+s), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Et(+s), o) : e;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Et(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
class wa {
  constructor(e, n) {
    this._context = e, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, n, e, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, e, this._y0, e, n);
        break;
      }
    }
    this._x0 = e, this._y0 = n;
  }
}
function xa(t) {
  return new wa(t, !0);
}
function xf(t) {
  return new wa(t, !1);
}
function gi(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function Cr(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Cr.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        gi(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        gi(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const bf = (function t(e) {
  function n(r) {
    return new Cr(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
})(0);
function Mf(t, e, n) {
  var r = t._x1, i = t._y1, a = t._x2, o = t._y2;
  if (t._l01_a > mi) {
    var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, l = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / l, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / l;
  }
  if (t._l23_a > mi) {
    var u = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, c = 3 * t._l23_a * (t._l23_a + t._l12_a);
    a = (a * u + t._x1 * t._l23_2a - e * t._l12_2a) / c, o = (o * u + t._y1 * t._l23_2a - n * t._l12_2a) / c;
  }
  t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
}
function ba(t, e) {
  this._context = t, this._alpha = e;
}
ba.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        Mf(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const Tf = (function t(e) {
  function n(r) {
    return e ? new ba(r, e) : new Cr(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
})(0.5);
function vi(t, e) {
  if ((o = t.length) > 1)
    for (var n = 1, r, i, a = t[e[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = t[e[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function ur(t) {
  for (var e = t.length, n = new Array(e); --e >= 0; ) n[e] = e;
  return n;
}
function Sf(t, e) {
  return t[e];
}
function kf(t) {
  const e = [];
  return e.key = t, e;
}
function Df() {
  var t = Et([]), e = ur, n = vi, r = Sf;
  function i(a) {
    var o = Array.from(t.apply(this, arguments), kf), s, l = o.length, u = -1, c;
    for (const f of a)
      for (s = 0, ++u; s < l; ++s)
        (o[s][u] = [0, +r(f, o[s].key, u, a)]).data = f;
    for (s = 0, c = pa(e(o)); s < l; ++s)
      o[c[s]].index = s;
    return n(o, c), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Et(Array.from(a)), i) : t;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Et(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (e = a == null ? ur : typeof a == "function" ? a : Et(Array.from(a)), i) : e;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? vi, i) : n;
  }, i;
}
function Cf(t, e) {
  if ((l = t.length) > 0)
    for (var n, r = 0, i, a, o, s, l, u = t[e[0]].length; r < u; ++r)
      for (o = s = 0, n = 0; n < l; ++n)
        (a = (i = t[e[n]][r])[1] - i[0]) > 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : (i[0] = 0, i[1] = a);
}
const Be = (t) => () => t;
function $f(t, {
  sourceEvent: e,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function Rt(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Rt.prototype = {
  constructor: Rt,
  scale: function(t) {
    return t === 1 ? this : new Rt(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Rt(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var $r = new Rt(1, 0, 0);
Rt.prototype;
function Ln(t) {
  t.stopImmediatePropagation();
}
function Te(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Ef(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function Af() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function pi() {
  return this.__zoom || $r;
}
function Nf(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function Pf() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Uf(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], i = t.invertX(e[1][0]) - n[1][0], a = t.invertY(e[0][1]) - n[0][1], o = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function Of() {
  var t = Ef, e = Af, n = Uf, r = Nf, i = Pf, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, l = Tu, u = Tn("start", "zoom", "end"), c, f, h, g = 500, S = 150, M = 0, A = 10;
  function x(_) {
    _.property("__zoom", pi).on("wheel.zoom", b, { passive: !1 }).on("mousedown.zoom", C).on("dblclick.zoom", R).filter(i).on("touchstart.zoom", w).on("touchmove.zoom", X).on("touchend.zoom touchcancel.zoom", Q).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  x.transform = function(_, P, y, O) {
    var W = _.selection ? _.selection() : _;
    W.property("__zoom", pi), _ !== W ? m(_, P, y, O) : W.interrupt().each(function() {
      p(this, arguments).event(O).start().zoom(null, typeof P == "function" ? P.apply(this, arguments) : P).end();
    });
  }, x.scaleBy = function(_, P, y, O) {
    x.scaleTo(_, function() {
      var W = this.__zoom.k, I = typeof P == "function" ? P.apply(this, arguments) : P;
      return W * I;
    }, y, O);
  }, x.scaleTo = function(_, P, y, O) {
    x.transform(_, function() {
      var W = e.apply(this, arguments), I = this.__zoom, L = y == null ? d(W) : typeof y == "function" ? y.apply(this, arguments) : y, k = I.invert(L), U = typeof P == "function" ? P.apply(this, arguments) : P;
      return n($(Y(I, U), L, k), W, o);
    }, y, O);
  }, x.translateBy = function(_, P, y, O) {
    x.transform(_, function() {
      return n(this.__zoom.translate(
        typeof P == "function" ? P.apply(this, arguments) : P,
        typeof y == "function" ? y.apply(this, arguments) : y
      ), e.apply(this, arguments), o);
    }, null, O);
  }, x.translateTo = function(_, P, y, O, W) {
    x.transform(_, function() {
      var I = e.apply(this, arguments), L = this.__zoom, k = O == null ? d(I) : typeof O == "function" ? O.apply(this, arguments) : O;
      return n($r.translate(k[0], k[1]).scale(L.k).translate(
        typeof P == "function" ? -P.apply(this, arguments) : -P,
        typeof y == "function" ? -y.apply(this, arguments) : -y
      ), I, o);
    }, O, W);
  };
  function Y(_, P) {
    return P = Math.max(a[0], Math.min(a[1], P)), P === _.k ? _ : new Rt(P, _.x, _.y);
  }
  function $(_, P, y) {
    var O = P[0] - y[0] * _.k, W = P[1] - y[1] * _.k;
    return O === _.x && W === _.y ? _ : new Rt(_.k, O, W);
  }
  function d(_) {
    return [(+_[0][0] + +_[1][0]) / 2, (+_[0][1] + +_[1][1]) / 2];
  }
  function m(_, P, y, O) {
    _.on("start.zoom", function() {
      p(this, arguments).event(O).start();
    }).on("interrupt.zoom end.zoom", function() {
      p(this, arguments).event(O).end();
    }).tween("zoom", function() {
      var W = this, I = arguments, L = p(W, I).event(O), k = e.apply(W, I), U = y == null ? d(k) : typeof y == "function" ? y.apply(W, I) : y, q = Math.max(k[1][0] - k[0][0], k[1][1] - k[0][1]), V = W.__zoom, st = typeof P == "function" ? P.apply(W, I) : P, at = l(V.invert(U).concat(q / V.k), st.invert(U).concat(q / st.k));
      return function(J) {
        if (J === 1) J = st;
        else {
          var ut = at(J), N = q / ut[2];
          J = new Rt(N, U[0] - ut[0] * N, U[1] - ut[1] * N);
        }
        L.zoom(null, J);
      };
    });
  }
  function p(_, P, y) {
    return !y && _.__zooming || new v(_, P);
  }
  function v(_, P) {
    this.that = _, this.args = P, this.active = 0, this.sourceEvent = null, this.extent = e.apply(_, P), this.taps = 0;
  }
  v.prototype = {
    event: function(_) {
      return _ && (this.sourceEvent = _), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(_, P) {
      return this.mouse && _ !== "mouse" && (this.mouse[1] = P.invert(this.mouse[0])), this.touch0 && _ !== "touch" && (this.touch0[1] = P.invert(this.touch0[0])), this.touch1 && _ !== "touch" && (this.touch1[1] = P.invert(this.touch1[0])), this.that.__zoom = P, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(_) {
      var P = lt(this.that).datum();
      u.call(
        _,
        this.that,
        new $f(_, {
          sourceEvent: this.sourceEvent,
          target: x,
          transform: this.that.__zoom,
          dispatch: u
        }),
        P
      );
    }
  };
  function b(_, ...P) {
    if (!t.apply(this, arguments)) return;
    var y = p(this, P).event(_), O = this.__zoom, W = Math.max(a[0], Math.min(a[1], O.k * Math.pow(2, r.apply(this, arguments)))), I = pt(_);
    if (y.wheel)
      (y.mouse[0][0] !== I[0] || y.mouse[0][1] !== I[1]) && (y.mouse[1] = O.invert(y.mouse[0] = I)), clearTimeout(y.wheel);
    else {
      if (O.k === W) return;
      y.mouse = [I, O.invert(I)], rn(this), y.start();
    }
    Te(_), y.wheel = setTimeout(L, S), y.zoom("mouse", n($(Y(O, W), y.mouse[0], y.mouse[1]), y.extent, o));
    function L() {
      y.wheel = null, y.end();
    }
  }
  function C(_, ...P) {
    if (h || !t.apply(this, arguments)) return;
    var y = _.currentTarget, O = p(this, P, !0).event(_), W = lt(_.view).on("mousemove.zoom", U, !0).on("mouseup.zoom", q, !0), I = pt(_, y), L = _.clientX, k = _.clientY;
    Xi(_.view), Ln(_), O.mouse = [I, this.__zoom.invert(I)], rn(this), O.start();
    function U(V) {
      if (Te(V), !O.moved) {
        var st = V.clientX - L, at = V.clientY - k;
        O.moved = st * st + at * at > M;
      }
      O.event(V).zoom("mouse", n($(O.that.__zoom, O.mouse[0] = pt(V, y), O.mouse[1]), O.extent, o));
    }
    function q(V) {
      W.on("mousemove.zoom mouseup.zoom", null), Vi(V.view, O.moved), Te(V), O.event(V).end();
    }
  }
  function R(_, ...P) {
    if (t.apply(this, arguments)) {
      var y = this.__zoom, O = pt(_.changedTouches ? _.changedTouches[0] : _, this), W = y.invert(O), I = y.k * (_.shiftKey ? 0.5 : 2), L = n($(Y(y, I), O, W), e.apply(this, P), o);
      Te(_), s > 0 ? lt(this).transition().duration(s).call(m, L, O, _) : lt(this).call(x.transform, L, O, _);
    }
  }
  function w(_, ...P) {
    if (t.apply(this, arguments)) {
      var y = _.touches, O = y.length, W = p(this, P, _.changedTouches.length === O).event(_), I, L, k, U;
      for (Ln(_), L = 0; L < O; ++L)
        k = y[L], U = pt(k, this), U = [U, this.__zoom.invert(U), k.identifier], W.touch0 ? !W.touch1 && W.touch0[2] !== U[2] && (W.touch1 = U, W.taps = 0) : (W.touch0 = U, I = !0, W.taps = 1 + !!c);
      c && (c = clearTimeout(c)), I && (W.taps < 2 && (f = U[0], c = setTimeout(function() {
        c = null;
      }, g)), rn(this), W.start());
    }
  }
  function X(_, ...P) {
    if (this.__zooming) {
      var y = p(this, P).event(_), O = _.changedTouches, W = O.length, I, L, k, U;
      for (Te(_), I = 0; I < W; ++I)
        L = O[I], k = pt(L, this), y.touch0 && y.touch0[2] === L.identifier ? y.touch0[0] = k : y.touch1 && y.touch1[2] === L.identifier && (y.touch1[0] = k);
      if (L = y.that.__zoom, y.touch1) {
        var q = y.touch0[0], V = y.touch0[1], st = y.touch1[0], at = y.touch1[1], J = (J = st[0] - q[0]) * J + (J = st[1] - q[1]) * J, ut = (ut = at[0] - V[0]) * ut + (ut = at[1] - V[1]) * ut;
        L = Y(L, Math.sqrt(J / ut)), k = [(q[0] + st[0]) / 2, (q[1] + st[1]) / 2], U = [(V[0] + at[0]) / 2, (V[1] + at[1]) / 2];
      } else if (y.touch0) k = y.touch0[0], U = y.touch0[1];
      else return;
      y.zoom("touch", n($(L, k, U), y.extent, o));
    }
  }
  function Q(_, ...P) {
    if (this.__zooming) {
      var y = p(this, P).event(_), O = _.changedTouches, W = O.length, I, L;
      for (Ln(_), h && clearTimeout(h), h = setTimeout(function() {
        h = null;
      }, g), I = 0; I < W; ++I)
        L = O[I], y.touch0 && y.touch0[2] === L.identifier ? delete y.touch0 : y.touch1 && y.touch1[2] === L.identifier && delete y.touch1;
      if (y.touch1 && !y.touch0 && (y.touch0 = y.touch1, delete y.touch1), y.touch0) y.touch0[1] = this.__zoom.invert(y.touch0[0]);
      else if (y.end(), y.taps === 2 && (L = pt(L, this), Math.hypot(f[0] - L[0], f[1] - L[1]) < A)) {
        var k = lt(this).on("dblclick.zoom");
        k && k.apply(this, arguments);
      }
    }
  }
  return x.wheelDelta = function(_) {
    return arguments.length ? (r = typeof _ == "function" ? _ : Be(+_), x) : r;
  }, x.filter = function(_) {
    return arguments.length ? (t = typeof _ == "function" ? _ : Be(!!_), x) : t;
  }, x.touchable = function(_) {
    return arguments.length ? (i = typeof _ == "function" ? _ : Be(!!_), x) : i;
  }, x.extent = function(_) {
    return arguments.length ? (e = typeof _ == "function" ? _ : Be([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), x) : e;
  }, x.scaleExtent = function(_) {
    return arguments.length ? (a[0] = +_[0], a[1] = +_[1], x) : [a[0], a[1]];
  }, x.translateExtent = function(_) {
    return arguments.length ? (o[0][0] = +_[0][0], o[1][0] = +_[1][0], o[0][1] = +_[0][1], o[1][1] = +_[1][1], x) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, x.constrain = function(_) {
    return arguments.length ? (n = _, x) : n;
  }, x.duration = function(_) {
    return arguments.length ? (s = +_, x) : s;
  }, x.interpolate = function(_) {
    return arguments.length ? (l = _, x) : l;
  }, x.on = function() {
    var _ = u.on.apply(u, arguments);
    return _ === u ? x : _;
  }, x.clickDistance = function(_) {
    return arguments.length ? (M = (_ = +_) * _, x) : Math.sqrt(M);
  }, x.tapDistance = function(_) {
    return arguments.length ? (A = +_, x) : A;
  }, x;
}
function wn() {
  return crypto ? crypto.randomUUID ? crypto.randomUUID() : Ff() : Yf();
}
function Ff() {
  return (+[1e7] + -1e3 + -4e3 + -8e3 + -1e11).toString().replace(
    /[018]/g,
    (t) => (+t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +t / 4).toString(16)
  );
}
function Yf() {
  const t = _i(), e = _i();
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-4${t.slice(13)}-a${e.slice(1, 4)}-${e.slice(4)}`;
}
function _i() {
  return `00000000000000000${(Math.random() * 18446744073709552e3).toString(16)}`.slice(-16);
}
const If = () => `chart-${wn()}`;
class Wf {
  id = If();
  height = K(0);
  width = K(0);
  padding = {
    top: 0,
    bottom: 0,
    middle: 0,
    left: 0,
    right: 0
  };
  container;
  resizeObserver;
  constructor(e, n) {
    this.container = e, n?.onResize && (this.onResize = n.onResize), n?.padding && (this.padding = { ...this.padding, ...n.padding });
  }
  get paddingY() {
    return this.padding.top + this.padding.middle + this.padding.bottom;
  }
  get paddingX() {
    return this.padding.left + this.padding.right;
  }
  initializeChart() {
    this.container.value && (this.resizeObserver = new ResizeObserver(this._onResize.bind(this)), this.resizeObserver.observe(this.container.value), this._onResize());
  }
  teardown() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }
  onResize() {
  }
  _onResize() {
    this.container.value && (this.height.value = this.container.value.offsetHeight, this.width.value = this.container.value.offsetWidth, this.onResize());
  }
}
const $n = (t, e) => {
  const n = new Wf(t, e);
  return Bt(() => {
    requestAnimationFrame(() => {
      n.initializeChart();
    });
  }), Di(() => {
    n.teardown();
  }), n;
}, Rf = ["id"], zf = { class: "bar-chart__bucket-container" }, Lf = {
  key: 1,
  class: "bar-chart__bucket",
  tabindex: "0"
}, Hf = {
  key: 1,
  class: "bar-chart__axis"
}, Cm = /* @__PURE__ */ Tt({
  __name: "BarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    chartPadding: {},
    axisPadding: {}
  },
  setup(t) {
    const e = Ci(), n = t, r = K(), i = xt(), a = Ht(), o = () => {
      s();
    }, s = () => {
      const M = n.intervalStart, A = n.intervalEnd;
      i.domain([M, A]).range([l.padding.left, l.width.value - l.paddingX]), a.domain([0, h.value || 1]).range([l.padding.top, l.height.value - l.padding.bottom]);
    }, l = $n(r, { onResize: o, padding: n.chartPadding }), { id: u } = l;
    jt(() => n.chartPadding, (M) => {
      l.padding = { ...l.padding, ...M };
    });
    const c = D(() => Math.floor(
      Math.min(10, (l.width.value - l.paddingX) / n.items.length / 2)
    )), f = D(() => n.items.filter((M) => M.value)), h = D(() => {
      const M = n.items.map((A) => A.value);
      return Math.max(...M);
    }), g = (M) => {
      const A = a(M.value), x = l.height.value - l.padding.bottom - A, Y = i(M.intervalStart) + l.padding.left;
      return {
        height: `${A}px`,
        left: `${Y}px`,
        top: `${x}px`,
        width: `${c.value}px`
      };
    }, S = D(() => ({
      bottom: `${l.padding.bottom - (n.axisPadding ?? 0)}px`
    }));
    return Bt(() => {
      s();
    }), Ea(() => {
      s();
    }), (M, A) => (B(), G("div", {
      ref_key: "container",
      ref: r,
      class: "bar-chart"
    }, [
      f.value.length ? (B(), G(zt, { key: 0 }, [
        (B(), G("svg", {
          id: it(u),
          class: "bar-chart__svg"
        }, null, 8, Rf)),
        F("div", zf, [
          (B(!0), G(zt, null, te(f.value, (x) => (B(), G("div", {
            key: x.intervalStart,
            style: gt(g(x)),
            class: "bar-chart__item"
          }, [
            it(e).default ? ot(M.$slots, "default", {
              key: 0,
              item: x
            }) : (B(), G("div", Lf))
          ], 4))), 128))
        ]),
        F("div", {
          class: "bar-chart__axis-container",
          style: gt(S.value)
        }, [
          it(e).axis ? ot(M.$slots, "axis", { key: 0 }) : (B(), G("div", Hf))
        ], 4)
      ], 64)) : ot(M.$slots, "empty", { key: 1 }, () => [
        A[0] || (A[0] = F("div", { class: "bar-chart__empty" }, " -- ", -1))
      ])
    ], 512));
  }
}), ce = 31536e3, Ae = 86400, an = 3600, lr = 60, yi = {
  years: 4,
  days: 3,
  hours: 2,
  minutes: 1,
  seconds: 0
}, Xf = {
  4: "years",
  3: "days",
  2: "hours",
  1: "minutes",
  0: "seconds"
}, Er = (t) => {
  const e = Math.floor(t / ce), n = Math.floor(t % ce / Ae), r = Math.floor(t % ce % Ae / an), i = Math.floor(t % ce % Ae % an / lr), a = Math.ceil(t % ce % Ae % an % lr);
  return { years: e, days: n, hours: r, minutes: i, seconds: a };
}, Ma = (t) => {
  const e = Math.floor(t / ce), n = Math.floor(t / Ae), r = Math.floor(t / an), i = Math.floor(t / lr);
  return { years: e, days: n, hours: r, minutes: i, seconds: t };
}, Vf = (t) => {
  const e = Er(t);
  return e.years > 0 ? "years" : e.days > 0 ? "days" : e.hours > 0 ? "hours" : e.minutes > 0 ? "minutes" : "seconds";
}, wi = (t) => {
  const { seconds: e, minutes: n, hours: r, days: i, years: a } = Ma(t), o = e == 0, s = n == 0, l = r == 0, u = i == 0, c = a == 0;
  return s && l && u && c ? "seconds" : !o && l && u && c ? "minutes" : !s && u && c ? "hours" : !l && c ? "days" : "years";
}, qf = (t) => {
  switch (t) {
    case "years":
      return Dt;
    case "days":
      return ae;
    case "hours":
      return Re;
    case "minutes":
      return We;
    case "seconds":
    default:
      return qt;
  }
}, Bf = (t) => {
  switch (t) {
    case "years":
      return "days";
    case "days":
      return "hours";
    case "hours":
      return "minutes";
    case "minutes":
      return "seconds";
    case "seconds":
    default:
      return "seconds";
  }
}, $m = (t) => {
  switch (t) {
    case "years":
      return "years";
    case "days":
      return "years";
    case "hours":
      return "days";
    case "minutes":
      return "hours";
    case "seconds":
    default:
      return "minutes";
  }
}, Em = (t, e, n = 5) => {
  const r = t.getTime() / 1e3, i = e.getTime() / 1e3, a = Er(i - r), o = Vf(i - r);
  let s = o;
  return a[o] < n && (s = Bf(o)), s;
};
function Gf(t, e = !0) {
  return `${t === 1 && !e ? "" : t}`;
}
function Se(t, e, n = !0) {
  return `${Gf(e, n)}${t}`;
}
function Qf(t, e = !0) {
  const { years: n, days: r, hours: i, minutes: a, seconds: o } = Er(t), s = Se("y", n, e), l = Se("d", r, e), u = Se("h", i, e), c = Se("m", a, e), f = Se("s", o, e);
  switch (!0) {
    case n > 0:
      return s;
    case r > 0:
      return l;
    case i > 0:
      return u;
    case a > 0:
      return c;
    default:
      return f;
  }
}
const Zf = Ft(".%L"), Kf = Ft(":%S"), Jf = Ft("%I:%M"), jf = Ft("%I %p"), th = Ft("%a %d"), eh = Ft("%b %d"), nh = Ft("%B"), rh = Ft("%Y"), ih = (t) => {
  if (typeof t != "number")
    return `${t.valueOf()}`;
  const e = Sr(".2f");
  return t === 0 ? "0s" : t < 1 ? `${e(t)}s` : `${Qf(t)}`;
}, Ar = (t) => t instanceof Date ? qt(t) < t ? Zf(t) : We(t) < t ? Kf(t) : Re(t) < t ? Jf(t) : ae(t) < t ? jf(t) : Cn(t) < t ? ze(t) < t ? th(t) : eh(t) : Dt(t) < t ? nh(t) : rh(t) : "", ah = ["id"], oh = {
  key: 1,
  class: "diverging-bar-chart__median"
}, sh = { class: "diverging-bar-chart__series-container" }, uh = {
  key: 1,
  class: "diverging-bar-chart__series-bar"
}, Am = /* @__PURE__ */ Tt({
  __name: "DivergingBarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    staticMedian: { type: Boolean },
    showAxis: { type: Boolean },
    axisClass: {},
    positiveSentimentKeys: {},
    negativeSentimentKeys: {},
    chartPadding: {}
  },
  setup(t) {
    const e = Ci(), n = t, r = D(() => {
      const d = new Map(n.positiveSentimentKeys.map((p) => [p, -1])), m = new Map(n.negativeSentimentKeys.map((p) => [p, 1]));
      return new Map([...d, ...m]);
    }), i = K(), a = K(xt()), o = K(Ht()), l = $n(i, { onResize: () => {
      $();
    }, padding: n.chartPadding }), { id: u } = l;
    let c;
    const f = D(() => {
      if (!n.items.length)
        return 1;
      const d = Math.floor(n.items.length * ((l.width.value - l.paddingX) / (n.items.length * 150)));
      return Math.max(d, 1);
    }), h = (d) => d.attr("class", () => {
      const m = d.attr("class").split(" "), p = n.axisClass?.split(" ") ?? [];
      return [...m, ...p.filter((b) => !m.includes(b))].join(" ");
    }).call(
      io(a.value).tickPadding(0).ticks(f.value).tickFormat(Ar).tickSizeInner(0).tickSizeOuter(0)
    ).call((m) => m.select(".domain").remove()).call((m) => m.selectAll(".tick").style("opacity", 1)), g = D(() => {
      const d = n.items.map((p) => p.data);
      return Df().keys([...n.positiveSentimentKeys, ...n.negativeSentimentKeys]).value((p, v) => {
        const b = r.value.get(v);
        return p[v] * (b ?? 1) || 0;
      }).order(ur).offset(Cf)(d);
    }), S = D(() => {
      const d = n.items.map((m, p) => {
        const v = g.value.map((b) => ({ key: b.key, value: b[p] }));
        return [m.intervalStart, { data: m, series: v }];
      });
      return new Map(d);
    }), M = (d) => {
      const m = a.value(d.intervalStart), p = a.value(d.intervalEnd);
      return {
        left: `${m}px`,
        width: `${p - m}px`
      };
    }, A = (d) => {
      const m = l.padding.middle / 2;
      let p = o.value(d[0]), v = o.value(d[1]);
      return d[0] < 0 ? (p -= m, v -= m) : (p += m, v += m), {
        height: `${Math.ceil(v - p)}px`,
        top: `${p}px`
      };
    }, x = D(() => o.value(0)), Y = D(() => ({
      top: `${x.value > 0 ? x.value : l.height.value / 2}px`
    })), $ = () => {
      const d = n.intervalStart, m = n.intervalEnd;
      let p = 0;
      n.showAxis && c ? (c.call(h), p = c.node()?.getBBox().height ?? 0, c.attr("transform", `translate(0, ${l.height.value - p / 2})`)) : c && c.selectAll(".tick").style("opacity", 0), a.value = xt().domain([d, m]).range([l.padding.left, l.width.value - l.paddingX]);
      const v = g.value.flat(2);
      let b = Math.min(...v), C = Math.max(...v);
      b == C && (b = -1, C = 1);
      const R = Ht().range([
        l.padding.top + l.padding.middle / 2,
        l.height.value - l.padding.bottom - l.padding.middle / 2 - p
      ]);
      if (n.staticMedian) {
        const w = Math.max(Math.abs(b), Math.abs(C));
        R.domain([-w, w]);
      } else
        R.domain([b, C]);
      o.value = R, n.showAxis && c ? c.call(h) : c && c.selectAll(".tick").style("opacity", 0);
    };
    return Bt(() => {
      c = lt(`#${u}`).select(".diverging-bar-chart__axis-group"), $();
    }), hr(() => {
      c = lt(`#${u}`).select(".diverging-bar-chart__axis-group"), l.padding = { ...l.padding, ...n.chartPadding }, $();
    }), (d, m) => (B(), G("div", {
      ref_key: "container",
      ref: i,
      class: "diverging-bar-chart"
    }, [
      (B(), G("svg", {
        id: it(u),
        class: "diverging-bar-chart__svg"
      }, [...m[0] || (m[0] = [
        F("g", { class: "diverging-bar-chart__axis-group" }, null, -1)
      ])], 8, ah)),
      n.items.length ? (B(), G(zt, { key: 0 }, [
        F("div", {
          class: "diverging-bar-chart__median-container",
          style: gt(Y.value)
        }, [
          it(e).median ? ot(d.$slots, "median", { key: 0 }) : (B(), G("div", oh))
        ], 4),
        F("div", sh, [
          (B(!0), G(zt, null, te(S.value, ([p, v]) => (B(), G("div", {
            key: p,
            class: "diverging-bar-chart__series",
            style: gt(M(v.data))
          }, [
            (B(!0), G(zt, null, te(v.series, (b) => (B(), G("div", {
              key: b.key,
              class: "diverging-bar-chart__series-point",
              style: gt(A(b.value))
            }, [
              it(e).default ? ot(d.$slots, "default", {
                key: b.key,
                value: b.value.data[b.key],
                series: v
              }) : (B(), G("div", uh))
            ], 4))), 128))
          ], 4))), 128))
        ])
      ], 64)) : ot(d.$slots, "empty", { key: 1 }, () => [
        m[1] || (m[1] = F("div", { class: "diverging-bar-chart__empty" }, " -- ", -1))
      ])
    ], 512));
  }
});
var Ge = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function lh(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Hn, xi;
function ch() {
  if (xi) return Hn;
  xi = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt, l = typeof Ge == "object" && Ge && Ge.Object === Object && Ge, u = typeof self == "object" && self && self.Object === Object && self, c = l || u || Function("return this")(), f = Object.prototype, h = f.toString, g = Math.max, S = Math.min, M = function() {
    return c.Date.now();
  };
  function A(m, p, v) {
    var b, C, R, w, X, Q, _ = 0, P = !1, y = !1, O = !0;
    if (typeof m != "function")
      throw new TypeError(t);
    p = d(p) || 0, x(v) && (P = !!v.leading, y = "maxWait" in v, R = y ? g(d(v.maxWait) || 0, p) : R, O = "trailing" in v ? !!v.trailing : O);
    function W(J) {
      var ut = b, N = C;
      return b = C = void 0, _ = J, w = m.apply(N, ut), w;
    }
    function I(J) {
      return _ = J, X = setTimeout(U, p), P ? W(J) : w;
    }
    function L(J) {
      var ut = J - Q, N = J - _, Z = p - ut;
      return y ? S(Z, R - N) : Z;
    }
    function k(J) {
      var ut = J - Q, N = J - _;
      return Q === void 0 || ut >= p || ut < 0 || y && N >= R;
    }
    function U() {
      var J = M();
      if (k(J))
        return q(J);
      X = setTimeout(U, L(J));
    }
    function q(J) {
      return X = void 0, O && b ? W(J) : (b = C = void 0, w);
    }
    function V() {
      X !== void 0 && clearTimeout(X), _ = 0, b = Q = C = X = void 0;
    }
    function st() {
      return X === void 0 ? w : q(M());
    }
    function at() {
      var J = M(), ut = k(J);
      if (b = arguments, C = this, Q = J, ut) {
        if (X === void 0)
          return I(Q);
        if (y)
          return X = setTimeout(U, p), W(Q);
      }
      return X === void 0 && (X = setTimeout(U, p)), w;
    }
    return at.cancel = V, at.flush = st, at;
  }
  function x(m) {
    var p = typeof m;
    return !!m && (p == "object" || p == "function");
  }
  function Y(m) {
    return !!m && typeof m == "object";
  }
  function $(m) {
    return typeof m == "symbol" || Y(m) && h.call(m) == n;
  }
  function d(m) {
    if (typeof m == "number")
      return m;
    if ($(m))
      return e;
    if (x(m)) {
      var p = typeof m.valueOf == "function" ? m.valueOf() : m;
      m = x(p) ? p + "" : p;
    }
    if (typeof m != "string")
      return m === 0 ? m : +m;
    m = m.replace(r, "");
    var v = a.test(m);
    return v || o.test(m) ? s(m.slice(2), v ? 2 : 8) : i.test(m) ? e : +m;
  }
  return Hn = A, Hn;
}
var fh = ch();
const hh = /* @__PURE__ */ lh(fh), dh = ["id"], mh = ["id"], gh = { class: "timeline__node-container" }, Nm = /* @__PURE__ */ Tt({
  __name: "Timeline",
  props: {
    start: {},
    end: {},
    items: {},
    axisTeleportTarget: {},
    hideAxis: { type: Boolean },
    axisClass: {},
    gridLineClass: {},
    intervalHeight: {},
    intervalWidth: {},
    nodeMinWidth: {},
    chartPadding: {}
  },
  setup(t) {
    const e = t, n = K(), r = K(), i = K(), a = K(!1), s = $n(i, { onResize: () => {
      L();
    }, padding: e.chartPadding }), { id: l } = s, u = K(xt());
    let c, f;
    const h = () => e.start ? new Date(e.start) : /* @__PURE__ */ new Date(), g = () => {
      const { end: k } = e, U = w.value, q = new Date(h()), V = new Date(Math.max(U?.getTime() ?? 0, q.getTime() + 3e4));
      switch (A.value) {
        case "years":
          V.setMonth(V.getMonth() + 1);
          break;
        case "days":
          V.setDate(V.getDate() + 1);
          break;
        case "hours":
          V.setHours(V.getHours() + 1);
          break;
        case "minutes":
          V.setMinutes(V.getMinutes() + 1);
          break;
        default:
          V.setSeconds(V.getSeconds() + 30);
      }
      return k && U ? new Date(Math.max(U.getTime(), k.getTime())) : V;
    }, S = K(e.intervalWidth ?? 84), M = K(e.intervalHeight ?? 32), A = D(() => {
      const k = e.items.filter((q) => q.end).map((q) => {
        const V = q.start.getTime() / 1e3, st = (q.end ?? e.end ?? /* @__PURE__ */ new Date()).getTime() / 1e3;
        return yi[wi(st - V)];
      });
      if (k.push(yi[wi(g().getTime() / 1e3 - h().getTime() / 1e3)]), k.length === 0)
        return "seconds";
      const U = Math.max(...k);
      return Xf[U];
    }), x = D(() => qf(A.value).every(1)), Y = D(() => {
      const k = h().getTime() / 1e3, U = g().getTime() / 1e3, q = Math.ceil(r.value.offsetWidth / S.value), V = Ma(U - k);
      return q > V[A.value] ? q : V[A.value];
    }), $ = D(() => Y.value * S.value), d = D(() => {
      const k = (p.value.size + 1) * M.value;
      return k < r.value?.offsetHeight ? r.value?.offsetHeight : k;
    }), m = (k) => {
      const U = u.value(k.start), q = u.value(k.end ?? /* @__PURE__ */ new Date()), V = p.value.get(k.id) * M.value, st = Math.max(e.nodeMinWidth ?? 32, q - U);
      return {
        height: `${M.value}px`,
        left: `${U}px`,
        top: `${V}px`,
        width: `${st}px`
      };
    }, p = K(/* @__PURE__ */ new Map()), v = () => {
      const k = [], U = /* @__PURE__ */ new Map();
      b.value.forEach((q) => {
        const { start: V } = q, st = q.end ?? V, at = u.value(V), J = u.value(st), ut = Math.max(e.nodeMinWidth ?? 32, J - at);
        let N = 0;
        for (; ; ) {
          const Z = k[N];
          if (Z) {
            const [, j] = Z;
            if (at > j) {
              k[N][1] = at + ut;
              break;
            } else {
              N++;
              continue;
            }
          } else {
            k[N] = [at, at + ut];
            break;
          }
        }
        U.set(q.id, N);
      }), p.value = U;
    }, b = D(() => [...e.items].sort((k, U) => new Date(k.start).getTime() - new Date(U.start).getTime())), C = D(() => e.items.filter((k) => k.end !== void 0).map((k) => k.end.getTime())), R = D(() => e.items.length && (!e.end || e.items.some((k) => !k.end))), w = D(() => {
      const k = Math.max(...C.value);
      return k === -1 / 0 ? null : new Date(k);
    }), X = (k, U) => (q) => q.attr("class", () => {
      const V = q.attr("class").split(" "), st = e.axisClass?.split(" ") ?? [];
      return [...V, ...st.filter((J) => !V.includes(J))].join(" ");
    }).call(
      Ai(k).tickPadding(0).ticks(U).tickFormat(Ar)
    ).call((V) => V.select(".domain").remove()), Q = () => {
      const k = h(), U = g();
      u.value = xt().domain([k, U]).range([s.padding.left, $.value - s.padding.right]).clamp(!0);
    }, _ = () => {
      e.hideAxis || c && c.call(X(u.value, x.value));
    }, P = () => {
      f && (f.selectAll(".timeline__grid-line.timeline__grid-line--x").data(Array.from({ length: Math.ceil(d.value / M.value) })).join(
        (k) => k.append("line").attr("id", (U, q) => `timeline__grid-line-x-${q}`).attr("class", `timeline__grid-line timeline__grid-line--x ${e.gridLineClass}`).attr("x1", 0).attr("x2", $.value).attr("y1", (U, q) => q * M.value).attr("y2", (U, q) => q * M.value),
        (k) => k.attr("x1", 0).attr("x2", $.value).attr("y1", (U, q) => q * M.value).attr("y2", (U, q) => q * M.value),
        (k) => k.remove()
      ), f.selectAll(".timeline__grid-line.timeline__grid-line--y").data(u.value.ticks(x.value)).join(
        (k) => k.append("line").attr("id", (U, q) => `x-${q}`).attr("class", `timeline__grid-line timeline__grid-line--y ${e.gridLineClass}`).attr("x1", (U) => u.value(U)).attr("x2", (U) => u.value(U)).attr("y1", 0).attr("y2", d.value),
        (k) => k.attr("x1", (U) => u.value(U)).attr("x2", (U) => u.value(U)).attr("y1", 0).attr("y2", d.value),
        (k) => k.remove()
      ).call(() => {
        R.value && L();
      }));
    }, y = () => {
      c = lt(`#${l}__axis`).select(".timeline__axis-group"), f = lt(`#${l}__grid`).select(".timeline__grid-group");
    }, O = () => {
      lt(`#${l}__axis`).attr("viewbox", `0, 0, ${$.value}, 24`).style("width", `${$.value}px`), lt(`#${l}__grid`).attr("viewbox", `0, 0, ${$.value}, ${d.value}`).style("width", `${$.value}px`).style("height", `${d.value}px`);
    }, W = () => {
      r.value?.scroll({ left: n.value.scrollLeft });
    }, I = () => {
      n.value?.scroll({ left: r.value.scrollLeft });
    }, L = hh(() => {
      requestAnimationFrame(() => {
        y(), O(), Q(), _(), P(), v();
      });
    }, 60, { maxWait: 120 });
    return Bt(() => {
      L(), a.value = !0;
    }), hr(() => {
      e.hideAxis || Aa(() => {
        L();
      });
    }), jt(() => [e.end, e.items, e.start], () => {
      L();
    }), jt(() => e.chartPadding, (k) => {
      s.padding = { ...s.padding, ...k };
    }), (k, U) => (B(), G("div", {
      ref_key: "container",
      ref: r,
      class: "timeline",
      onScroll: I
    }, [
      F("main", {
        ref_key: "chart",
        ref: i,
        class: "timeline__viewport",
        style: gt({ height: `${d.value}px` })
      }, [
        a.value && !k.hideAxis ? (B(), Na(Pa(k.axisTeleportTarget ? Ua : "div"), {
          key: 0,
          to: k.axisTeleportTarget,
          class: "timeline__axis-container"
        }, {
          default: Oa(() => [
            F("nav", {
              ref_key: "axis",
              ref: n,
              class: "timeline__nav",
              onScroll: W
            }, [
              (B(), G("svg", {
                id: `${it(l)}__axis`,
                class: "timeline__axis"
              }, [...U[0] || (U[0] = [
                F("g", { class: "timeline__axis-group" }, null, -1)
              ])], 8, dh))
            ], 544)
          ]),
          _: 1
        }, 8, ["to"])) : _t("", !0),
        (B(), G("svg", {
          id: `${it(l)}__grid`,
          class: "timeline__grid"
        }, [...U[1] || (U[1] = [
          F("g", { class: "timeline__grid-group" }, null, -1)
        ])], 8, mh)),
        F("div", gh, [
          (B(!0), G(zt, null, te(k.items, (q, V) => (B(), G("div", {
            key: V,
            class: "timeline__node",
            style: gt(m(q))
          }, [
            ot(k.$slots, "default", { node: q }, () => [
              U[2] || (U[2] = F("div", { class: "timeline__node-content" }, null, -1))
            ])
          ], 4))), 128))
        ])
      ], 4)
    ], 544));
  }
});
function vh(t) {
  return t.some((e) => e === void 0);
}
const ph = ["id"], Pm = /* @__PURE__ */ Tt({
  __name: "ScatterPlot",
  props: {
    items: {},
    yTicks: { default: 5 },
    startDate: { default: null },
    endDate: { default: null },
    showNowLine: { type: Boolean },
    dotDiameter: { default: 14 },
    chartPadding: { default: () => ({ top: 16, left: 40, bottom: 48, right: 0 }) }
  },
  setup(t) {
    const e = t, n = K(), r = K(xt()), i = K(Ht()), a = D(() => e.items), s = $n(n, { onResize: () => {
      $();
    }, padding: e.chartPadding }), { id: l } = s;
    let u;
    const c = D(() => {
      const b = (s.width.value - s.paddingX) / 100;
      return Math.max(2, Math.ceil(b));
    }), f = (v) => v.call(
      Ai(r.value).tickPadding(10).tickSizeInner(5).tickSizeOuter(0).ticks(c.value).tickFormat(Ar)
    );
    let h;
    const g = (v) => v.call(
      ao(i.value).tickPadding(10).tickSizeInner(-(s.width.value - s.paddingX)).tickFormat(ih).tickValues(p())
    ), S = (v) => v.x, M = (v) => v.y, A = (v) => {
      const b = i.value(v.y) + s.padding.top - e.dotDiameter / 2, C = r.value(v.x);
      return {
        height: `${e.dotDiameter}px`,
        width: `${e.dotDiameter}px`,
        left: `${C}px`,
        top: `${b}px`
      };
    }, x = () => {
      const [v, b] = Y(), C = /* @__PURE__ */ new Date();
      return v > C || b < C ? null : {
        left: `${r.value(C) + e.dotDiameter}px`
      };
    }, Y = () => {
      let v = Pr(a.value, S);
      if (vh(v)) {
        const b = /* @__PURE__ */ new Date(), C = b.setDate(b.getDate() - 1);
        v = [new Date(C), b];
      }
      return e.startDate && (v[0] = e.startDate), e.endDate && (v[1] = e.endDate), v;
    }, $ = () => {
      d(), m(), u && (u.call(f), u.attr("transform", `translate(${e.dotDiameter}, ${s.height.value - s.padding.bottom + e.dotDiameter})`), u.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--x"), u.select(".domain").remove()), h && (h.call(g), h.attr("transform", `translate(${s.padding.left}, ${s.padding.top})`), h.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--y"), h.selectAll(".tick line").attr("class", "scatter-plot__tick-line"), h.select(".domain").remove());
    }, d = () => {
      const v = Y();
      r.value = xt().domain(v).range([s.padding.left, s.width.value - s.paddingX - s.padding.right]);
    }, m = () => {
      let [, b = 0] = Pr(a.value, M);
      b = Math.max(b, 1), i.value = Ht().domain([0, b]).range([s.height.value - s.paddingY, 0]);
    }, p = () => {
      const [v, b] = i.value.domain(), C = (b - v) / (e.yTicks - 1);
      return Ka(v, b + C, C);
    };
    return Bt(() => {
      const v = lt(`#${l}`);
      u = v.select(".scatter-plot__x-axis-group"), h = v.select(".scatter-plot__y-axis-group"), $();
    }), jt(() => e.chartPadding, (v) => {
      s.padding = { ...s.padding, ...v };
    }), jt(() => e.items, () => $()), (v, b) => (B(), G("div", {
      ref_key: "container",
      ref: n,
      class: "scatter-plot"
    }, [
      (B(), G("svg", {
        id: it(l),
        class: "scatter-plot__svg"
      }, [...b[0] || (b[0] = [
        F("g", { class: "scatter-plot__x-axis-group" }, null, -1),
        F("g", { class: "scatter-plot__y-axis-group" }, null, -1)
      ])], 8, ph)),
      (B(!0), G(zt, null, te(a.value, (C) => (B(), G("div", {
        key: C.id,
        style: gt(A(C)),
        class: At(["scatter-plot__dot", C.itemClass])
      }, [
        ot(v.$slots, "default", { item: C })
      ], 6))), 128)),
      v.showNowLine && x() ? (B(), G("div", {
        key: 0,
        class: "scatter-plot__now",
        style: gt(x())
      }, null, 4)) : _t("", !0)
    ], 512));
  }
});
function xn(t) {
  "@babel/helpers - typeof";
  return xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xn(t);
}
function Xt(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function ct(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function ht(t) {
  ct(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || xn(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ta(t, e) {
  ct(2, arguments);
  var n = ht(t).getTime(), r = Xt(e);
  return new Date(n + r);
}
var _h = {};
function En() {
  return _h;
}
function yh(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function wh(t) {
  ct(1, arguments);
  var e = ht(t);
  return e.setHours(0, 0, 0, 0), e;
}
function on(t, e) {
  ct(2, arguments);
  var n = Xt(e);
  return Ta(t, n * 1e3);
}
function xh(t) {
  return ct(1, arguments), t instanceof Date || xn(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function bh(t) {
  if (ct(1, arguments), !xh(t) && typeof t != "number")
    return !1;
  var e = ht(t);
  return !isNaN(Number(e));
}
function Mh(t, e) {
  return ct(2, arguments), ht(t).getTime() - ht(e).getTime();
}
var Th = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, Sh = "trunc";
function kh(t) {
  return Th[Sh];
}
function Dh(t) {
  ct(1, arguments);
  var e = ht(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Ch(t, e, n) {
  ct(2, arguments);
  var r = Mh(t, e) / 1e3;
  return kh()(r);
}
function $h() {
  return Dh(Date.now());
}
function Eh(t, e) {
  ct(2, arguments);
  var n = Xt(e);
  return Ta(t, -n);
}
var Ah = 864e5;
function Nh(t) {
  ct(1, arguments);
  var e = ht(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), i = n - r;
  return Math.floor(i / Ah) + 1;
}
function bn(t) {
  ct(1, arguments);
  var e = 1, n = ht(t), r = n.getUTCDay(), i = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function Sa(t) {
  ct(1, arguments);
  var e = ht(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = bn(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = bn(a);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function Ph(t) {
  ct(1, arguments);
  var e = Sa(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = bn(n);
  return r;
}
var Uh = 6048e5;
function Oh(t) {
  ct(1, arguments);
  var e = ht(t), n = bn(e).getTime() - Ph(e).getTime();
  return Math.round(n / Uh) + 1;
}
function Mn(t, e) {
  var n, r, i, a, o, s, l, u;
  ct(1, arguments);
  var c = En(), f = Xt((n = (r = (i = (a = e?.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : c.weekStartsOn) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ht(t), g = h.getUTCDay(), S = (g < f ? 7 : 0) + g - f;
  return h.setUTCDate(h.getUTCDate() - S), h.setUTCHours(0, 0, 0, 0), h;
}
function ka(t, e) {
  var n, r, i, a, o, s, l, u;
  ct(1, arguments);
  var c = ht(t), f = c.getUTCFullYear(), h = En(), g = Xt((n = (r = (i = (a = e?.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = h.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(f + 1, 0, g), S.setUTCHours(0, 0, 0, 0);
  var M = Mn(S, e), A = /* @__PURE__ */ new Date(0);
  A.setUTCFullYear(f, 0, g), A.setUTCHours(0, 0, 0, 0);
  var x = Mn(A, e);
  return c.getTime() >= M.getTime() ? f + 1 : c.getTime() >= x.getTime() ? f : f - 1;
}
function Fh(t, e) {
  var n, r, i, a, o, s, l, u;
  ct(1, arguments);
  var c = En(), f = Xt((n = (r = (i = (a = e?.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = c.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = ka(t, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(h, 0, f), g.setUTCHours(0, 0, 0, 0);
  var S = Mn(g, e);
  return S;
}
var Yh = 6048e5;
function Ih(t, e) {
  ct(1, arguments);
  var n = ht(t), r = Mn(n, e).getTime() - Fh(n, e).getTime();
  return Math.round(r / Yh) + 1;
}
function nt(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var Vt = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return nt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : nt(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return nt(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return nt(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return nt(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return nt(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return nt(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, i = e.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return nt(a, n.length);
  }
}, le = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wh = {
  // Era
  G: function(e, n, r) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Vt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, i) {
    var a = ka(e, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var s = o % 100;
      return nt(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : nt(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = Sa(e);
    return nt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return nt(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return nt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return nt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Vt.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return nt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, i) {
    var a = Ih(e, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : nt(a, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var i = Oh(e);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : nt(i, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Vt.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var i = Nh(e);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : nt(i, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var i = e.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return nt(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return nt(o, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var i = e.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return nt(a, n.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var i = e.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i === 12 ? a = le.noon : i === 0 ? a = le.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i >= 17 ? a = le.evening : i >= 12 ? a = le.afternoon : i >= 4 ? a = le.morning : a = le.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Vt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Vt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : nt(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : nt(i, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Vt.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Vt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Vt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Mi(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Qt(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Qt(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Mi(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Qt(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Qt(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + bi(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Qt(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + bi(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Qt(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, i) {
    var a = i._originalDate || e, o = Math.floor(a.getTime() / 1e3);
    return nt(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTime();
    return nt(o, n.length);
  }
};
function bi(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var o = e;
  return n + String(i) + o + nt(a, 2);
}
function Mi(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + nt(Math.abs(t) / 60, 2);
  }
  return Qt(t, e);
}
function Qt(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", i = Math.abs(t), a = nt(Math.floor(i / 60), 2), o = nt(i % 60, 2);
  return r + a + n + o;
}
var Ti = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Da = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Rh = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return Ti(e, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Ti(i, n)).replace("{{time}}", Da(a, n));
}, zh = {
  p: Da,
  P: Rh
}, Lh = ["D", "DD"], Hh = ["YY", "YYYY"];
function Xh(t) {
  return Lh.indexOf(t) !== -1;
}
function Vh(t) {
  return Hh.indexOf(t) !== -1;
}
function Si(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var qh = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Bh = function(e, n, r) {
  var i, a = qh[e];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Xn(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var Gh = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Qh = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Zh = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kh = {
  date: Xn({
    formats: Gh,
    defaultWidth: "full"
  }),
  time: Xn({
    formats: Qh,
    defaultWidth: "full"
  }),
  dateTime: Xn({
    formats: Zh,
    defaultWidth: "full"
  })
}, Jh = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, jh = function(e, n, r, i) {
  return Jh[e];
};
function ke(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = t.formattingValues[o] || t.formattingValues[a];
    } else {
      var s = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[l] || t.values[s];
    }
    var u = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[u];
  };
}
var td = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ed = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, nd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, rd = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, id = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ad = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, od = function(e, n) {
  var r = Number(e), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, sd = {
  ordinalNumber: od,
  era: ke({
    values: td,
    defaultWidth: "wide"
  }),
  quarter: ke({
    values: ed,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: ke({
    values: nd,
    defaultWidth: "wide"
  }),
  day: ke({
    values: rd,
    defaultWidth: "wide"
  }),
  dayPeriod: ke({
    values: id,
    defaultWidth: "wide",
    formattingValues: ad,
    defaultFormattingWidth: "wide"
  })
};
function De(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(i);
    if (!a)
      return null;
    var o = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? ld(s, function(f) {
      return f.test(o);
    }) : ud(s, function(f) {
      return f.test(o);
    }), u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = n.valueCallback ? n.valueCallback(u) : u;
    var c = e.slice(o.length);
    return {
      value: u,
      rest: c
    };
  };
}
function ud(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function ld(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function cd(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r) return null;
    var i = r[0], a = e.match(t.parsePattern);
    if (!a) return null;
    var o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = e.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var fd = /^(\d+)(th|st|nd|rd)?/i, hd = /\d+/i, dd = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, md = {
  any: [/^b/i, /^(a|c)/i]
}, gd = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, _d = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, yd = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, wd = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, xd = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, bd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Md = {
  ordinalNumber: cd({
    matchPattern: fd,
    parsePattern: hd,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: De({
    matchPatterns: dd,
    defaultMatchWidth: "wide",
    parsePatterns: md,
    defaultParseWidth: "any"
  }),
  quarter: De({
    matchPatterns: gd,
    defaultMatchWidth: "wide",
    parsePatterns: vd,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: De({
    matchPatterns: pd,
    defaultMatchWidth: "wide",
    parsePatterns: _d,
    defaultParseWidth: "any"
  }),
  day: De({
    matchPatterns: yd,
    defaultMatchWidth: "wide",
    parsePatterns: wd,
    defaultParseWidth: "any"
  }),
  dayPeriod: De({
    matchPatterns: xd,
    defaultMatchWidth: "any",
    parsePatterns: bd,
    defaultParseWidth: "any"
  })
}, Td = {
  code: "en-US",
  formatDistance: Bh,
  formatLong: Kh,
  formatRelative: jh,
  localize: sd,
  match: Md,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Sd = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, kd = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Dd = /^'([^]*?)'?$/, Cd = /''/g, $d = /[a-zA-Z]/;
function Fe(t, e, n) {
  var r, i, a, o, s, l, u, c, f, h, g, S, M, A;
  ct(2, arguments);
  var x = String(e), Y = En(), $ = (r = (i = void 0) !== null && i !== void 0 ? i : Y.locale) !== null && r !== void 0 ? r : Td, d = Xt((a = (o = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : Y.firstWeekContainsDate) !== null && o !== void 0 ? o : (u = Y.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(d >= 1 && d <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = Xt((f = (h = (g = (S = void 0) !== null && S !== void 0 ? S : void 0) !== null && g !== void 0 ? g : Y.weekStartsOn) !== null && h !== void 0 ? h : (M = Y.locale) === null || M === void 0 || (A = M.options) === null || A === void 0 ? void 0 : A.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!$.localize)
    throw new RangeError("locale must contain localize property");
  if (!$.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var p = ht(t);
  if (!bh(p))
    throw new RangeError("Invalid time value");
  var v = yh(p), b = Eh(p, v), C = {
    firstWeekContainsDate: d,
    weekStartsOn: m,
    locale: $,
    _originalDate: p
  }, R = x.match(kd).map(function(w) {
    var X = w[0];
    if (X === "p" || X === "P") {
      var Q = zh[X];
      return Q(w, $.formatLong);
    }
    return w;
  }).join("").match(Sd).map(function(w) {
    if (w === "''")
      return "'";
    var X = w[0];
    if (X === "'")
      return Ed(w);
    var Q = Wh[X];
    if (Q)
      return Vh(w) && Si(w, e, String(t)), Xh(w) && Si(w, e, String(t)), Q(b, w, $.localize, C);
    if (X.match($d))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + X + "`");
    return w;
  }).join("");
  return R;
}
function Ed(t) {
  var e = t.match(Dd);
  return e ? e[1].replace(Cd, "'") : t;
}
function Qe(t, e) {
  ct(2, arguments);
  var n = ht(t), r = ht(e);
  return n.getTime() > r.getTime();
}
function Ze(t, e) {
  ct(2, arguments);
  var n = ht(t), r = ht(e);
  return n.getTime() < r.getTime();
}
function Ad() {
  return wh(Date.now());
}
function Vn(t, e) {
  ct(2, arguments);
  var n = Xt(e);
  return on(t, -n);
}
function cr(t) {
  return Fe(t, "MMM do, yyyy");
}
function fr(t) {
  return Fe(t, "hh:mm a");
}
const Nd = { class: "chart-cursor__label" }, Pd = { class: "chart-cursor__date" }, Ud = { class: "chart-cursor__time" }, Um = /* @__PURE__ */ Tt({
  __name: "ChartCursor",
  props: {
    startDate: {},
    endDate: {},
    cursor: {}
  },
  emits: ["update:cursor"],
  setup(t, { emit: e }) {
    const n = t, r = e, i = K(), { width: a } = Ut(i), o = K(), { width: s } = Ut(o), l = K(null), u = K(!1), { down: c } = Ei("Shift"), f = D({
      get() {
        return n.cursor ?? l.value;
      },
      set(m) {
        l.value = m, r("update:cursor", m);
      }
    }), h = D(() => {
      if (f.value === null)
        return !1;
      const m = S.value(f.value), p = g.value(f.value);
      return m === p;
    }), g = D(() => {
      const m = xt();
      return m.domain([n.startDate, n.endDate]), m.range([0, a.value]), m;
    }), S = D(() => g.value.copy().clamp(!0)), M = D(() => {
      if (!f.value || !c.value)
        return {
          display: "none"
        };
      const m = g.value(f.value);
      return {
        left: bt(m)
      };
    }), A = D(() => {
      if (!f.value || !c.value)
        return {
          display: "none"
        };
      const m = g.value(f.value), p = s.value / 2;
      let v = m - p;
      return v < 0 && (v = 0), v + s.value > a.value && (v = a.value - s.value), {
        left: bt(v)
      };
    });
    function x(m) {
      u.value = !0, d(m);
    }
    function Y(m) {
      d(m);
    }
    function $() {
      f.value = null, u.value = !1;
    }
    function d(m) {
      const [p] = pt(m, i.value);
      f.value = S.value.invert(p);
    }
    return (m, p) => (B(), G("div", dr({
      ref_key: "chart",
      ref: i,
      class: "chart-cursor"
    }, { onPointerenter: x, onPointermove: Y, onPointerleave: $ }), [
      ot(m.$slots, "default"),
      h.value ? (B(), G("div", {
        key: 0,
        class: "chart-cursor__cursor",
        style: gt(M.value)
      }, null, 4)) : _t("", !0),
      f.value && u.value ? (B(), G("div", {
        key: 1,
        ref_key: "label",
        ref: o,
        class: "chart-cursor__label-wrapper",
        style: gt(A.value)
      }, [
        ot(m.$slots, "label", { value: f.value }, () => [
          F("div", Nd, [
            F("span", Pd, vt(it(cr)(f.value)), 1),
            F("span", Ud, vt(it(fr)(f.value)), 1)
          ])
        ])
      ], 4)) : _t("", !0)
    ], 16));
  }
}), Om = /* @__PURE__ */ Tt({
  __name: "ChartZoom",
  props: {
    startDate: {},
    endDate: {},
    options: {}
  },
  emits: ["update:startDate", "update:endDate", "updated"],
  setup(t, { emit: e }) {
    const n = t, r = e, { startDate: i, endDate: a } = Fa(n), o = K(), { width: s } = Ut(o), { down: l } = Ei("Shift"), u = Of().on("start", A).on("zoom", x).on("end", Y).filter((m) => !m.shiftKey), c = D(() => {
      const m = xt();
      return m.domain([i.value, a.value]), m.range([0, s.value]), m;
    }), f = K(!1), h = D(() => ({
      "chart-zoom--enabled": !l.value,
      "chart-zoom--dragging": f.value
    }));
    let g = !1, S = !1;
    jt(c, () => {
      o.value && g && ($(), g = !1);
    }), Bt(() => {
      M();
    });
    function M() {
      o.value && lt(o.value).call(u);
    }
    function A({ sourceEvent: m }) {
      m.type === "mousedown" && (f.value = !0);
    }
    function x(m) {
      if (S) {
        S = !1;
        return;
      }
      const p = m.transform.rescaleX(c.value), [v, b] = p.domain(), C = d({ startDate: v, endDate: b });
      if (C === null) {
        $();
        return;
      }
      r("update:startDate", C.startDate), r("update:endDate", C.endDate), g = !0;
    }
    function Y() {
      f.value = !1, r("updated", {
        startDate: n.startDate,
        endDate: n.endDate
      });
    }
    function $() {
      o.value && (lt(o.value).call(u.transform, $r), S = !0);
    }
    function d({ startDate: m, endDate: p }) {
      const {
        minRangeInSeconds: v = -1 / 0,
        maxRangeInSeconds: b = 1 / 0
      } = n.options ?? {};
      let C = m.getTime(), R = p.getTime();
      const w = R - C, X = n.endDate.getTime() - n.startDate.getTime(), Q = n.options?.minDate?.getTime() ?? -1 / 0, _ = n.options?.maxDate?.getTime() ?? 1 / 0, P = v * 1e3, y = b * 1e3, O = w < X && X <= P, W = w > X && X >= y;
      if (O || W)
        return null;
      if (w > y) {
        const L = (w - y) / 2;
        C = C + L, R = R - L;
      }
      if (w < P) {
        const L = (P - w) / 2;
        C = C - L, R = R + L;
      }
      if (C < Q) {
        const I = Q - C;
        C = C + I, R = R + I;
      }
      if (R > _) {
        const I = R - _;
        C = C - I, R = R - I;
      }
      return {
        startDate: new Date(C),
        endDate: new Date(R)
      };
    }
    return (m, p) => (B(), G("div", {
      ref_key: "chart",
      ref: o,
      class: At(["chart-zoom", h.value])
    }, [
      ot(m.$slots, "default", Ya(Ia({ startDate: it(i), endDate: it(a) })))
    ], 2));
  }
}), Od = { class: "chart-labels__chart" }, Fd = {
  key: 0,
  class: "chart-labels__y"
}, Yd = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--min" }, Id = { class: "chart-labels__value-label" }, Wd = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--max" }, Rd = { class: "chart-labels__value-label" }, zd = {
  key: 1,
  class: "chart-labels__x"
}, Ld = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--start" }, Hd = { class: "chart-labels__date-label" }, Xd = { class: "chart-labels__time-label" }, Vd = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--end" }, qd = { class: "chart-labels__date-label" }, Bd = { class: "chart-labels__time-label" }, Fm = /* @__PURE__ */ Tt({
  __name: "ChartLabels",
  props: {
    xAxis: {},
    yAxis: {}
  },
  setup(t) {
    const e = t, n = D(() => ({
      root: {
        "chart-labels--x": e.xAxis,
        "chart-labels--y": e.yAxis
      }
    })), r = D(() => e.xAxis?.at(0)), i = D(() => e.xAxis?.at(-1)), a = D(() => e.yAxis?.at(0)), o = D(() => e.yAxis?.at(-1));
    return (s, l) => (B(), G("div", {
      class: At(["chart-labels", n.value.root])
    }, [
      F("div", Od, [
        ot(s.$slots, "default")
      ]),
      s.yAxis ? (B(), G("div", Fd, [
        F("div", Yd, [
          ot(s.$slots, "label-y", { value: o.value }, () => [
            F("span", Id, vt(o.value), 1)
          ])
        ]),
        F("div", Wd, [
          ot(s.$slots, "label-y", { value: a.value }, () => [
            F("span", Rd, vt(a.value), 1)
          ])
        ])
      ])) : _t("", !0),
      s.xAxis ? (B(), G("div", zd, [
        F("div", Ld, [
          r.value ? ot(s.$slots, "label-x", {
            key: 0,
            value: r.value
          }, () => [
            F("span", Hd, vt(it(cr)(r.value)), 1),
            F("span", Xd, vt(it(fr)(r.value)), 1)
          ]) : _t("", !0)
        ]),
        F("div", Vd, [
          i.value ? ot(s.$slots, "label-x", {
            key: 0,
            value: i.value
          }, () => [
            F("span", qd, vt(it(cr)(i.value)), 1),
            F("span", Bd, vt(it(fr)(i.value)), 1)
          ]) : _t("", !0)
        ])
      ])) : _t("", !0)
    ], 2));
  }
}), Ym = /* @__PURE__ */ Tt({
  __name: "ChartPlayHead",
  props: {
    startDate: {},
    endDate: {}
  },
  setup(t) {
    const e = t, n = K(), { width: r } = Ut(n), i = K(), { width: a } = Ut(i), { now: o } = za(), s = D(() => {
      const u = xt();
      return u.domain([e.startDate, e.endDate]), u.range([0, r.value]), u;
    }), l = D(() => {
      const u = s.value(o.value) - a.value / 2;
      return {
        left: bt(u)
      };
    });
    return (u, c) => (B(), G("div", {
      ref_key: "chart",
      ref: n,
      class: "chart-play-head"
    }, [
      ot(u.$slots, "default"),
      F("div", {
        ref_key: "line",
        ref: i,
        class: "chart-play-head__now",
        style: gt(l.value)
      }, null, 4)
    ], 512));
  }
});
function qn(t) {
  return t.slice().sort((e, n) => e.getTime() - n.getTime());
}
function Ca(t, e) {
  return t.slice().sort((n, r) => {
    const i = n[e], a = r[e];
    return i.getTime() - a.getTime();
  });
}
const Im = /* @__PURE__ */ Tt({
  __name: "ChartSelection",
  props: {
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["selection", "update:selectionStart", "update:selectionEnd"],
  setup(t, { emit: e }) {
    const n = t, r = e;
    Bt(() => {
      x(), document.addEventListener("pointermove", $);
    }), Di(() => {
      document.removeEventListener("pointermove", $);
    });
    const i = D(() => {
      const v = xt();
      return v.domain([n.startDate, n.endDate]), v.range([0, o.value]), v;
    }), a = K(), { width: o } = Ut(a), s = K(), { width: l } = Ut(s), u = D(() => n.selectionStart ?? null), c = D(() => n.selectionEnd ?? null), f = K(!1), h = K(null), g = K(null), S = D(() => !u.value || !c.value ? null : qn([u.value, c.value])), M = D(() => {
      if (!u.value || !c.value)
        return {
          display: "none"
        };
      const [v, b] = qn([u.value, c.value]), C = i.value(v), R = o.value - i.value(b);
      return {
        left: bt(C),
        right: bt(R)
      };
    }), A = D(() => {
      if (!u.value || !c.value)
        return {
          display: "none"
        };
      const v = i.value(u.value), b = i.value(c.value), C = (v + b) / 2, R = l.value / 2;
      let w = C - R;
      return w < 0 && (w = 0), w + l.value > o.value && (w = o.value - l.value), {
        left: bt(w)
      };
    });
    function x() {
      if (!a.value)
        return;
      const v = tn().on("start", Y).on("end", d).filter((b) => b.shiftKey);
      lt(a.value).call(v);
    }
    function Y(v) {
      f.value = !0, h.value = null, g.value = null;
      const [b] = pt(v, a.value);
      h.value = i.value.clamp(!0).invert(b), m();
    }
    function $(v) {
      if (!f.value)
        return;
      const [b] = pt(v, a.value), C = i.value.clamp(!0).invert(b);
      g.value = C, m();
    }
    function d() {
      f.value = !1, r("selection", S.value);
    }
    function m() {
      if (!h.value || !g.value) {
        r("update:selectionStart", null), r("update:selectionEnd", null);
        return;
      }
      const [v, b] = qn([h.value, g.value]);
      r("update:selectionStart", v), r("update:selectionEnd", b);
    }
    function p(v) {
      return Fe(v, "MMM do, hh:mm a");
    }
    return (v, b) => (B(), G("div", {
      ref_key: "chart",
      ref: a,
      class: "chart-selection",
      onPointermove: $
    }, [
      ot(v.$slots, "default"),
      F("div", {
        class: "chart-selection__selection",
        style: gt(M.value)
      }, null, 4),
      F("div", {
        ref_key: "label",
        ref: s,
        class: "chart-selection__label",
        style: gt(A.value)
      }, [
        u.value && c.value ? ot(v.$slots, "label", {
          key: 0,
          start: u.value,
          end: c.value
        }, () => [
          Wa(vt(p(u.value)) + " - " + vt(p(c.value)), 1)
        ]) : _t("", !0)
      ], 4)
    ], 544));
  }
});
function $a(t, e) {
  const n = Gd(t), r = Math.ceil(t / n) * n;
  return r === t ? r + n : r;
}
const ki = {
  25: 5,
  100: 10,
  150: 25,
  500: 50,
  1e3: 100,
  1e4: 1e3,
  1e5: 1e5,
  Infinity: 1e6
};
function Gd(t) {
  const e = Object.keys(ki).map(Number).find((n) => t < n);
  return ki[e];
}
const Qd = { class: "histogram-chart__chart" }, Zd = ["width", "height", "viewbox"], Kd = ["id", "y1"], Jd = ["d"], jd = ["d"], tm = {
  key: 0,
  class: "histogram-chart__axis-y"
}, em = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--min" }, nm = { class: "histogram-chart__value-label" }, rm = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--max" }, im = {
  key: 1,
  class: "histogram-chart__axis-x"
}, am = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--start" }, om = { class: "histogram-chart__date-label" }, sm = { class: "histogram-chart__time-label" }, um = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--end" }, lm = { class: "histogram-chart__date-label" }, cm = { class: "histogram-chart__time-label" }, Wm = /* @__PURE__ */ Tt({
  __name: "HistogramChart",
  props: {
    data: {},
    smooth: { type: Boolean },
    options: {},
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["update:selectionStart", "update:selectionEnd", "selection"],
  setup(t, { emit: e }) {
    $i((E) => ({
      fb75021e: o.value,
      "0c2f9d70": g.value
    }));
    const n = t, r = e, i = D(() => ({
      ...fm,
      ...n.options
    })), a = D(() => Ca(n.data, "intervalStart")), o = D(() => `${i.value.transitionDuration}ms`), s = D(() => !n.smooth), l = D(() => n.smooth), u = D(() => n.selectionEnd && n.selectionStart), c = K(!1), f = K(!0), h = D(() => `histogram-path-gradient-${wn()}`), g = D(() => `url(#${h.value})`), S = jt(u, (E) => {
      E && (mt(), S());
    });
    Bt(() => {
      u.value && (S(), mt()), rt();
    });
    const M = K(), { width: A, height: x, x: Y } = Ut(M), $ = K(), d = K(), m = K();
    hr(() => document.body.classList.toggle("histogram-chart--dragging", c.value));
    const p = D(() => a.value.at(0).intervalStart), v = D(() => n.startDate ? n.startDate : p.value), b = D(() => a.value.at(-1).intervalEnd), C = D(() => n.endDate ? n.endDate : b.value), R = D(() => {
      const E = a.value.map((z) => z.value), H = Math.max(...E, 0);
      return $a(H);
    }), w = D(() => {
      const E = xt();
      return E.domain([v.value, C.value]), E.range([0, A.value]), E;
    }), X = D(() => {
      const E = Ht();
      return E.domain([0, R.value]), E.range([0, x.value]), E;
    }), Q = D(() => a.value.map((E) => I(E))), _ = D(() => {
      const E = a.value.at(0), H = a.value.at(-1), z = a.value.map((Nn) => L(Nn)), [, et = 0] = z.shift() ?? [], [, ft = et] = z.pop() ?? [], Yt = w.value(E.intervalStart), $t = w.value(H.intervalEnd), ye = [Yt, et], An = [$t, ft];
      return [
        ye,
        ...z,
        An
      ];
    }), P = D(() => {
      const E = ya();
      return E.curve(i.value.curve), E(_.value) ?? "";
    }), y = D(() => {
      const E = P.value, H = `L ${w.value(b.value)},${x.value}`, z = `L ${w.value(p.value)},${x.value}`;
      return `${E}${H}${z}Z`;
    }), O = D(() => {
      const { selectionStart: E, selectionEnd: H } = n;
      if (!E || !H)
        return;
      const z = w.value(E), et = A.value - w.value(H);
      return {
        left: `${z}px`,
        right: `${et}px`
      };
    }), W = D(() => ({
      root: {
        "histogram-chart--loading": f.value,
        "histogram-chart--x-axis": i.value.showXAxis,
        "histogram-chart--y-axis": i.value.showYAxis
      },
      selection: {
        "histogram-chart__selection--moving": c.value
      },
      bar: {
        "histogram-chart__bar--transitioned": i.value.transition,
        "histogram-chart__bar--visible": s.value
      },
      path: {
        "histogram-chart__path--transitioned": i.value.transition,
        "histogram-chart__path--visible": l.value
      }
    }));
    function I(E) {
      const H = X.value(E.value), z = w.value(E.intervalStart), ft = w.value(E.intervalEnd) - z, Yt = H, $t = {
        left: bt(z),
        width: bt(ft),
        height: bt(Yt),
        bottom: bt(0)
      };
      return (f.value || !s.value) && ($t.height = bt(0)), { ...E, styles: $t };
    }
    function L(E) {
      const H = new Date((E.intervalStart.getTime() + E.intervalEnd.getTime()) / 2), z = w.value(H), et = x.value - X.value(E.value);
      return f.value || !l.value ? [z, x.value] : [z, et];
    }
    function k(E) {
      return Fe(E, "MMM do, yyyy");
    }
    function U(E) {
      return Fe(E, "hh:mm a");
    }
    function q({ selectionStart: E, selectionEnd: H }) {
      const z = v.value, et = C.value, ft = Ch(H, E);
      return Ze(E, z) ? {
        selectionStart: z,
        selectionEnd: on(z, ft)
      } : Qe(H, et) ? {
        selectionStart: Vn(et, ft),
        selectionEnd: et
      } : { selectionStart: E, selectionEnd: H };
    }
    function V() {
      c.value = !0;
    }
    function st(E) {
      if (!n.selectionStart || !n.selectionEnd)
        return;
      V();
      const [H] = pt(E, M.value), z = w.value(n.selectionStart), et = w.value(n.selectionEnd);
      if (H >= z && H <= et)
        return;
      const ft = et - z, Yt = Math.floor(ft / 2), $t = H - Yt, ye = $t + ft, An = w.value.invert($t), Nr = w.value.invert(ye), Nn = q({ selectionStart: An, selectionEnd: Nr });
      T(Nn);
    }
    function at() {
      c.value = !1, r("selection", {
        selectionStart: n.selectionStart,
        selectionEnd: n.selectionEnd
      });
    }
    function J({ dx: E }) {
      const H = w.value(n.selectionStart), z = w.value(n.selectionEnd), et = w.value.invert(H + E), ft = w.value.invert(z + E);
      return { selectionStart: et, selectionEnd: ft };
    }
    function ut(E) {
      if (j(E))
        return;
      const H = J(E), z = q(H);
      T(z);
    }
    function N(E) {
      const [H] = pt(E, M.value);
      let z = w.value.invert(H);
      Ze(z, v.value) && (z = v.value);
      const et = Vn(n.selectionEnd, i.value.selectionMaximumSeconds);
      Ze(z, et) && (z = et);
      const ft = Vn(n.selectionEnd, i.value.selectionMinimumSeconds);
      Qe(z, ft) && (z = ft), T({
        selectionStart: z
      });
    }
    function Z(E) {
      const [H] = pt(E, M.value);
      let z = w.value.invert(H);
      Qe(z, C.value) && (z = C.value);
      const et = on(n.selectionStart, i.value.selectionMaximumSeconds);
      Qe(z, et) && (z = et);
      const ft = on(n.selectionStart, i.value.selectionMinimumSeconds);
      Ze(z, ft) && (z = ft), T({
        selectionEnd: z
      });
    }
    function j(E) {
      const H = E.dx, z = Y.value, et = Y.value + A.value, Yt = E.sourceEvent.clientX - H, $t = z >= Yt, ye = et <= Yt;
      return !!($t || ye);
    }
    function T({ selectionStart: E, selectionEnd: H }) {
      E && r("update:selectionStart", E), H && r("update:selectionEnd", H);
    }
    function mt() {
      if (!M.value || !$.value || !d.value || !m.value)
        return;
      const E = lt(M.value), H = tn().on("start", st).on("drag", ut).on("end", at), z = tn().container(E).on("start", V).on("drag", N).on("end", at), et = tn().container(E).on("start", V).on("drag", Z).on("end", at);
      lt(M.value).call(H), lt(d.value).call(z), lt(m.value).call(et);
    }
    function rt() {
      setTimeout(() => {
        f.value = !1;
      }, 1);
    }
    return (E, H) => a.value.length ? (B(), G("div", {
      key: 0,
      class: At(["histogram-chart", W.value.root])
    }, [
      F("div", {
        ref_key: "chart",
        ref: M,
        class: "histogram-chart__viewport"
      }, [
        u.value ? (B(), G("div", {
          key: 0,
          ref_key: "selection",
          ref: $,
          class: At(["histogram-chart__selection", W.value.selection]),
          style: gt(O.value)
        }, [
          F("div", {
            ref_key: "selectionLeft",
            ref: d,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--left"
          }, null, 512),
          F("div", {
            ref_key: "selectionRight",
            ref: m,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--right"
          }, null, 512)
        ], 6)) : _t("", !0),
        F("div", Qd, [
          (B(), G("svg", {
            class: "histogram-chart__svg",
            width: it(A),
            height: it(x),
            viewbox: `0 0 ${it(A)} ${it(x)}`
          }, [
            F("defs", null, [
              ot(E.$slots, "defs", {}, () => [
                F("linearGradient", {
                  id: h.value,
                  x1: "0",
                  y1: it(x),
                  x2: "0",
                  y2: "0",
                  gradientUnits: "userSpaceOnUse"
                }, [...H[0] || (H[0] = [
                  F("stop", {
                    offset: "0%",
                    class: "histogram-chart__path--0"
                  }, null, -1),
                  F("stop", {
                    offset: "85%",
                    class: "histogram-chart__path--85"
                  }, null, -1),
                  F("stop", {
                    offset: "100%",
                    class: "histogram-chart__path--100"
                  }, null, -1)
                ])], 8, Kd),
                H[1] || (H[1] = F("linearGradient", {
                  id: "histogram-fill-gradient",
                  x1: "50%",
                  y1: "100%",
                  x2: "50%",
                  y2: "0%"
                }, [
                  F("stop", {
                    offset: "0%",
                    class: "histogram-chart__gradient-start"
                  }),
                  F("stop", {
                    offset: "100%",
                    class: "histogram-chart__gradient-stop"
                  })
                ], -1))
              ])
            ]),
            F("path", {
              class: At(["histogram-chart__path", W.value.path]),
              d: P.value
            }, null, 10, Jd),
            F("path", {
              class: At(["histogram-chart__fill", W.value.path]),
              d: y.value
            }, null, 10, jd)
          ], 8, Zd)),
          (B(!0), G(zt, null, te(Q.value, (z) => ot(E.$slots, "bar", dr({
            key: z.intervalStart.getTime(),
            ref_for: !0
          }, z), () => [
            F("div", {
              class: At(["histogram-chart__bar", W.value.bar]),
              style: gt(z.styles)
            }, null, 6)
          ])), 128))
        ])
      ], 512),
      i.value.showYAxis ? (B(), G("div", tm, [
        F("div", em, [
          ot(E.$slots, "label-y", { value: R.value }, () => [
            F("span", nm, vt(R.value), 1)
          ])
        ]),
        F("div", rm, [
          ot(E.$slots, "label-y", { value: 0 }, () => [
            H[2] || (H[2] = F("span", { class: "histogram-chart__value-label" }, vt(0), -1))
          ])
        ])
      ])) : _t("", !0),
      i.value.showXAxis ? (B(), G("div", im, [
        F("div", am, [
          ot(E.$slots, "label-x", { value: v.value }, () => [
            F("span", om, vt(k(v.value)), 1),
            F("span", sm, vt(U(v.value)), 1)
          ])
        ]),
        F("div", um, [
          ot(E.$slots, "label-x", { value: C.value }, () => [
            F("span", lm, vt(k(C.value)), 1),
            F("span", cm, vt(U(C.value)), 1)
          ])
        ])
      ])) : _t("", !0)
    ], 2)) : _t("", !0);
  }
}), fm = {
  showXAxis: !0,
  showYAxis: !0,
  curve: xa,
  transition: !0,
  transitionDuration: 250,
  selectionMaximumSeconds: 1 / 0,
  selectionMinimumSeconds: 0
};
function hm(t) {
  if (typeof t == "function")
    return t;
  switch (t) {
    case "bumpX":
      return xa;
    case "bumpY":
      return xf;
    case "cardinal":
      return bf;
    case "catmullRom":
      return Tf;
  }
}
const dm = ["width", "height", "viewbox"], mm = ["id", "y1"], gm = ["id"], vm = ["d"], pm = ["d"], Rm = /* @__PURE__ */ Tt({
  __name: "LineChart",
  props: {
    data: {},
    options: {}
  },
  setup(t) {
    $i((d) => ({
      "3658dfef": l.value,
      "563e115e": u.value
    }));
    const e = t, n = K(), { width: r, height: i } = Ut(n), a = D(() => e.data.slice().sort(([d], [m]) => d.getTime() - m.getTime())), o = D(() => `histogram-path-gradient-${wn()}`), s = D(() => `line-chart-fill-gradient-${wn()}`), l = D(() => `url(#${o.value})`), u = D(() => `url(#${s.value})`), c = D(() => {
      if (e.options?.startDate)
        return e.options.startDate;
      const [d] = a.value.at(0) ?? [];
      return d ?? Ad();
    }), f = D(() => {
      if (e.options?.endDate)
        return e.options.endDate;
      const [d] = a.value.at(-1) ?? [];
      return d ?? $h();
    }), h = D(() => {
      const d = xt();
      return d.domain([c.value, f.value]), d.range([0, r.value]), d;
    }), g = D(() => a.value.map(([, d]) => d)), S = D(() => e.options?.minValue !== void 0 ? e.options.minValue : Math.min(...g.value, 0)), M = D(() => {
      if (e.options?.maxValue !== void 0)
        return e.options.maxValue;
      const d = Math.max(...g.value, 0);
      return e.options?.roundUpMaxValue ? $a(d) : d;
    }), A = D(() => {
      const d = Ht();
      return d.domain([S.value, M.value]), d.range([i.value, 0]), d;
    }), x = D(() => a.value.map(([d, m]) => [h.value(d), A.value(m)])), Y = D(() => {
      const d = ya();
      if (e.options?.curve) {
        const m = hm(e.options.curve);
        d.curve(m);
      }
      return d(x.value);
    }), $ = D(() => {
      if (!Y.value)
        return null;
      const [d, m] = h.value.range(), [p] = x.value.at(0) ?? [d], [v] = x.value.at(-1) ?? [m], b = `L ${v},${i.value}`, C = `L ${p},${i.value}`;
      return `${Y.value}${b}${C}Z`;
    });
    return (d, m) => (B(), G("div", {
      ref_key: "chart",
      ref: n,
      class: "line-chart"
    }, [
      (B(), G("svg", {
        class: "line-chart__svg",
        width: it(r),
        height: it(i),
        viewbox: `0 0 ${it(r)} ${it(i)}`
      }, [
        F("defs", null, [
          F("linearGradient", {
            id: o.value,
            x1: "0",
            y1: it(i),
            x2: "0",
            y2: "0",
            gradientUnits: "userSpaceOnUse"
          }, [...m[0] || (m[0] = [
            F("stop", {
              offset: "0%",
              class: "line-chart__path--0"
            }, null, -1),
            F("stop", {
              offset: "85%",
              class: "line-chart__path--85"
            }, null, -1),
            F("stop", {
              offset: "100%",
              class: "line-chart__path--100"
            }, null, -1)
          ])], 8, mm),
          F("linearGradient", {
            id: s.value,
            x1: "50%",
            y1: "100%",
            x2: "50%",
            y2: "0%"
          }, [...m[1] || (m[1] = [
            F("stop", {
              offset: "0%",
              class: "line-chart__gradient-start"
            }, null, -1),
            F("stop", {
              offset: "100%",
              class: "line-chart__gradient-stop"
            }, null, -1)
          ])], 8, gm)
        ]),
        Y.value ? (B(), G("path", {
          key: 0,
          class: "line-chart__path",
          d: Y.value
        }, null, 8, vm)) : _t("", !0),
        $.value ? (B(), G("path", {
          key: 1,
          class: "line-chart__fill",
          d: $.value
        }, null, 8, pm)) : _t("", !0)
      ], 8, dm))
    ], 512));
  }
}), _m = ["onClick"], zm = /* @__PURE__ */ Tt({
  __name: "MiniHistogram",
  props: {
    data: {},
    options: {}
  },
  emits: ["barClick"],
  setup(t, { emit: e }) {
    const n = t, r = e, { value: i } = Ra(), a = K(), { width: o } = Ut(a), s = D(() => Ca(n.data, "intervalStart")), l = D(() => s.value.map((d) => Y(d))), u = D(() => ({
      colorStart: "#7210EF",
      colorEnd: "#A564F9",
      ...n.options
    })), c = D(() => ({
      root: {
        "mini-histogram--clickable-bars": n.options?.clickable
      },
      bar: {
        "mini-histogram__bar--clickable": n.options?.clickable
      }
    })), f = D(() => n.options?.startDate ? n.options.startDate : s.value.at(0)?.intervalStart ?? /* @__PURE__ */ new Date()), h = D(() => n.options?.endDate ? n.options.endDate : s.value.at(-1)?.intervalEnd ?? /* @__PURE__ */ new Date()), g = D(() => {
      const d = xt();
      return d.domain([f.value, h.value]), d.range([0, o.value]), d;
    }), S = D(() => s.value.map((d) => d.value)), M = D(() => n.options?.minValue !== void 0 ? n.options.minValue : Math.min(...S.value, 0)), A = D(() => n.options?.maxValue !== void 0 ? n.options.maxValue : Math.max(...S.value, 0)), x = D(() => {
      const d = Ht(), m = [u.value.colorStart, u.value.colorEnd];
      return i.value === "dark" && m.reverse(), d.domain([M.value, A.value]), d.range(m), d;
    });
    function Y(d) {
      const m = g.value(d.intervalStart), v = g.value(d.intervalEnd) - m, b = {
        left: bt(m),
        width: bt(v),
        backgroundColor: x.value(d.value)
      };
      return { ...d, styles: b };
    }
    function $(d) {
      n.options?.clickable && r("barClick", d);
    }
    return (d, m) => (B(), G("div", {
      ref_key: "chart",
      ref: a,
      class: At(["mini-histogram", c.value.root])
    }, [
      (B(!0), G(zt, null, te(l.value, (p) => ot(d.$slots, "bar", dr({
        key: p.intervalStart.getTime(),
        ref_for: !0
      }, p), () => [
        F("div", {
          class: At(["mini-histogram__bar", c.value.bar]),
          style: gt(p.styles),
          onClick: () => $(p)
        }, null, 14, _m)
      ])), 128))
    ], 2));
  }
});
function ym() {
  return {
    cursor: K(null)
  };
}
function wm() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = ym();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Lm = wm();
function xm() {
  const t = K(null), e = K(null);
  return {
    startDate: t,
    endDate: e
  };
}
function bm() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = xm();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Hm = bm();
function Mm() {
  const t = K(null), e = K(null);
  return {
    selectionStart: t,
    selectionEnd: e
  };
}
function Tm() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = Mm();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Xm = Tm(), Vm = (t = {
  capTop: !0,
  capBottom: !0,
  x: 0,
  y: 0,
  height: 0,
  width: 0,
  radius: 1
}) => {
  const { capTop: e, capBottom: n, height: r, width: i, x: a, y: o, radius: s } = t, l = e ? `a ${s} ${s} 0 1 0 -${i} 0` : `a 0 0 0 1 0 -${i} 0`, u = n ? `a ${s} ${s} 0 1 0 ${i} 0` : `a 0 0 0 1 0 ${i} 0`;
  return `M${a},${o} v${r} ${u} ${n ? "" : `h${i}`} v-${r} ${l}`;
}, qm = (t, e) => {
  if (typeof t != "object")
    throw new Error('stringAccessor: passed object is not of type "object"');
  if (typeof e != "string")
    throw new Error('stringAccessor: passed string is not of type "string"');
  return e = e.replace(/\[["'`](.*)["'`]\]/g, ".$1"), e.split(".").reduce((n, r) => n ? n[r] : void 0, t || self);
};
export {
  Cm as BarChart,
  Um as ChartCursor,
  Fm as ChartLabels,
  Ym as ChartPlayHead,
  Im as ChartSelection,
  Om as ChartZoom,
  Am as DivergingBarChart,
  Wm as HistogramChart,
  Rm as LineChart,
  zm as MiniHistogram,
  Pm as ScatterPlot,
  yi as TimeIntervalRanking,
  Xf as TimeIntervalReverseRanking,
  Nm as Timeline,
  Er as aggregateSeconds,
  Vm as createCappedBar,
  fm as defaultHistogramChartOptions,
  vh as extentUndefined,
  th as formatDay,
  jf as formatHour,
  Ar as formatLabel,
  Zf as formatMillisecond,
  Jf as formatMinute,
  nh as formatMonth,
  Kf as formatSecond,
  ih as formatTime,
  eh as formatWeek,
  rh as formatYear,
  qf as getD3IntervalMethod,
  Vf as getLargestInterval,
  Em as getMinInterval,
  $m as getNextHighestInterval,
  Bf as getNextLowestInterval,
  wi as getSmallestInterval,
  Ma as intervalSeconds,
  Qf as secondsToApproximateString,
  qm as stringAccessor,
  Lm as useChartCursor,
  Xm as useChartSelection,
  Hm as useChartZoom
};
//# sourceMappingURL=vue-charts.js.map
